<template>
<el-container>
  <publicHeader :currencyShow="currencyShow" :curPageData="this.curPageData" @hotelLanguage="hotelLanguage" @getfirstName="getfirstName" v-if="ismobile === false"></publicHeader>
  <el-main>
    <div class="main" v-if="ismobile === false">
      <!--步骤条-->
      <div class="stepinfo">
          <div :class="'step-line-one-'+language">
            <i class="el-step__line-inner" style="transition-delay: 0ms; border-width: 0px; width: 100%;background-color: #4f4c4c;height: 1px;top: 14.5px;"></i>
          </div>
          <div :class="'step-line-two-'+language">
            <i class="el-step__line-inner" style="transition-delay: 0ms; border-width: 0px; width: 100%;background-color: #4f4c4c;height: 1px;top: 14.5px;"></i>
          </div>
          <div :class="'order-step-new-'+language" style="float: left;">
            <img class="step-img" src="https://res.roompai.com/static/img/order/y-one.png"> <span class="step-text">{{$t('hoteInformation')}}</span>
          </div>
          <div :class="'order-step-new-'+language">
            <img class="step-img" src="https://res.roompai.com/static/img/order/y-two.png"> <span class="step-text">{{$t('customerInformation')}}</span>
          </div>
          <div :class="'order-step-new-'+language" style="float: right;">
            <img class="step-img" src="https://res.roompai.com/static/img/order/b-three.png"> <span class="step-text">{{$t('finalStep')}}</span>
          </div>
        </div>
        <!--步骤条结束-->
      <div class="msg-main">
        <!--右侧部分-->
        <OrderRight :hotelOut="hotel" :orderDataOut="orderData" :source="source" :language="language" :ismobile="ismobile" :paymentOn="paymentOn" :TransactionFeeshowOut="TransactionFeeshow"></OrderRight>
        <div class="msg-left">
          <!--登录/注册入口-->
          <div class="msg-blue" v-if="!loginStatus">
            <div class="blue-tag">
              <div class='blue-back'>
                <img class="blue-logo" src="/static/img/order/pay-user.png">
              </div>
            </div>
            <div class="blue-text" style="width: 90%; white-space: nowrap;overflow: hidden;display: inline-flex;line-height: 50px;">
              <div style="width: 50%;">
                <span style="padding: 0px 10px;">{{$t('hello')}} {{firstName}}</span>
              </div>
              <div style="width: 50%;text-align: right;color: #303133;">
              </div>
            </div>
          </div>
          <!--倒计时-->
          <div class="msg-pink" :class="[{'msg-bule-show':loginStatus}]">
            <div class="pink-tag">
              <div class='pink-back'>
                <img class="pink-logo" src="/static/img/order/pay-hour.png">
              </div>
            </div>
            <div class="pink-text">
              <span>{{$t('please')}}</span>
              <span class="pink-maintext">
                  {{minuteString + ':'+ secondString}}
                </span>
              <span>{{$t('orderPaymentRight')}}</span>
            </div>
          </div>
          <!--住客资料-->
          <form class="el-form demo-ruleForm">
            <div class="msg-guest">
              <div style="padding: 2px 20px;">
                <p style="font-size:22px; font-weight:650;">{{$t('customerInformationDesc')}}</p>
                <!--客房2 等等-->
                <div v-for="(value, id) in customInfo" :key="id">
                  <div :style="id>0 ? 'margin-top:50px' : ''">
                    <div style="font-size:14px; font-weight:650;">{{$t('roomName')}} {{id + 1}}</div>
                    <div style="margin-bottom:15px;" v-if="language === 'zh'">
                      <div class="msg-lastname" style="float: left;">
                        <div for="name" class="msg-name">{{$t('lastName')}}：{{$t('pleaseEnglishLetter')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input"><input type="text" class="el-input__inner" :value="value.lastname" disabled></div>
                        </div>
                      </div>
                      <div class="msg-username" style="margin-left: 1%;">
                        <div for="name" class="msg-name">{{$t('firstName')}}：{{$t('pleaseEnglishLetter')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <input type="text" class="el-input__inner" :value="value.firstname" disabled>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="margin-bottom:15px;" v-else>
                      <div class="msg-username" tyle="float: left;">
                        <div for="name" class="msg-name">{{$t('firstName')}}：{{$t('pleaseEnglishLetter')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <input type="text" class="el-input__inner" :value="value.firstname" disabled>
                          </div>
                        </div>
                      </div>
                      <div class="msg-lastname" style="margin-left: 1%;">
                        <div for="name" class="msg-name">{{$t('lastName')}}：{{$t('pleaseEnglishLetter')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <input type="text" class="el-input__inner" :value="value.lastname" disabled>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="margin-bottom:15px;" v-if="id===0">
                      <div for="name" class="msg-name">{{$t('emailAddr')}}<span style="color:red;">*</span></div>
                      <div class="el-form-item__content">
                        <div class="el-input">
                          <input type="text" class="el-input__inner" :value="value.email" disabled>
                        </div>
                      </div>
                    </div>
                    <div style="margin-bottom:15px;" id="paymentTypeTop">
                      <div class="msg-lastname" style="float:left;" v-if="id===0">
                        <div for="name" class="msg-name">{{$t('phoneNumber')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input input-bor">
                            <el-select style="width:35%;" v-model="value.areaCode" :placeholder="$t('pleaseSelect')" disabled>
                              <el-option v-for="item in telOptions" :label="item.telnum" :key="item.id" :value="item.id">{{item.value}}</el-option>
                            </el-select>
                            <input style="width:63.5%;" type="text" class="el-input__inner" :value="value.phoneNum" disabled>
                          </div>
                        </div>
                      </div>
                      <div class="msg-username" style="margin-left: 1%;">
                        <div for="name" class="msg-name">{{$t('nationality')}}</div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <el-select style="width:100%;" v-model="value.nationality" filterable disabled>
                              <el-option v-for="item in telOptions" :key="item.id" :label="item.country" :value="item.id">{{item.country}}</el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--支付方式-->
            <form class="el-form demo-ruleForm">
              <div class="msg-guest">
                <div style="padding: 2px 20px;">
                  <el-tabs v-model="activeName">
                    <div class="msg-green">
                      <div :class="'green-text-'+language">
                        <img class="green-logo" src="/static/img/order/dun.png">
                        <span>{{$t('encryptedSecure')}}</span>
                      </div>
                    </div>
                    <!-- 电子支付 -->
                    <el-tab-pane :label="$t('payMethod')" name="electronicPayment">
                      <div>
                        <img v-for="item in paymentList" :key="item.value" :src="item.src" style="width:38px; height:25px; margin-right: 5px;">
                        <!-- <img src="/static/img/order/jcb.png" style="width:38px; height:25px; margin-right: 5px;">
                        <img src="/static/img/order/master.png" style="width:38px; height:25px; margin-right: 5px;">
                        <img src="/static/img/order/visa-cart.png" style="width:38px; height:25px; margin-right: 5px;">
                        <img src="/static/img/order/diners.png" style="width:38px; height:25px; margin-right: 5px;">
                        <img src="/static/img/order/discover.png" style="width:38px; height:25px; margin-right: 5px;">
                        <img src="/static/img/order/american.png" style="width:38px; height:25px; margin-right: 5px;"> -->
                      </div>
                      <div>
                        <div class="long-margin" style="padding-bottom: 20px; background:#fff;">
                          <div>
                            <div for="name" class="msg-name">{{$t('payMethod')}}: </div>
                            <div class="el-form-item__content">
                              <div class="el-input">
                                <el-select v-model="paymentOn" placeholder="请选择" @change="changePayment(paymentOn)" ref="paymentSelect" style="width:70%">
                                  <el-option v-for="item in paymentList" :key="item.value" :label="getLanguageHtml(item,'paymentLabel')" :value="item.value">
                                    <span style="float: left"><img :src="item.src" style="width:38px; height:25px;vertical-align: middle;margin-right: 10px;"></span>
                                    <span style="float: left;" v-html="getLanguageHtml(item,'paymentLabel')"></span>
                                  </el-option>
                                </el-select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="long-margin" style="background:#fff;">
                          <div>
                            <div for="name" class="msg-name"></div>
                            <div class="el-form-item__content">
                              <li style="line-height: 25px;" v-if="['paypal', 'alipay'].includes(paymentOn)">{{$t('youSelectPay')}}<span v-html="getLanguageHtml(paymentOn,'paymentLabelShow')" style="font-weight: 400;color: #5392F9;"></span>{{$t('youWillBeForwardedTo')}}<span v-html="getLanguageHtml(paymentOn,'paymentLabelShow')" style="font-weight: 400;color: #5392F9;"></span>{{$t('websiteToProceedWithThisTransaction')}}</li>
                              <li style="line-height: 25px;" v-if="discountPrice === ''">{{$t('theTotalAmountYouChanged')}} <span style="font-weight: 400;color: #5392F9;" v-if="paymentOn === 'wechat'">{{orderData.totalPriceCNY}}</span><span style="font-weight: 400;color: #5392F9;" v-if="paymentOn === 'paypal' || paymentOn === 'pingpong' || paymentOn === 'credit-card'"><a v-if="TransactionFeeshow === true">{{transactionFeeInfo[paymentOn].totalPPriceUSD}}</a><a v-else>{{orderData.totalPriceUSD}}</a></span><span v-if="TransactionFeeshow === true">{{$t('TransactionFeeMsgFirst')}} {{transactionFeeInfo[paymentOn].TFeeTagUSD}} {{$t('TransactionFeeMsgLast')}}</span></li>
                              <li style="line-height: 25px;" v-else>{{$t('theTotalAmountYouChanged')}} <span style="font-weight: 400;color: #5392F9;" v-if="paymentOn === 'wechat'">{{orderData.discountTotalPriceCNY}}</span><span style="font-weight: 400;color: #5392F9;" v-if="paymentOn === 'paypal' || paymentOn === 'pingpong' || paymentOn === 'credit-card'"><a v-if="TransactionFeeshow === true">{{discountFeeInfo[paymentOn].discountTotalPriceUSD}}</a><a v-else>{{orderData.discountTotalPriceUSD}}</a></span><span v-if="TransactionFeeshow === true">{{$t('TransactionFeeMsgFirst')}} {{discountFeeInfo[paymentOn].discountTFeeTagUSD}} {{$t('TransactionFeeMsgLast')}}</span></li>
                            </div>
                          </div>
                        </div>
                        <div class="long-margin" v-if="paymentOn === 'pingpong'">
                          <div id="creditPayment" style="position: relative; height: 770px; width: 95%;margin-top: 15px;">
                            <!-- <div id="payment-pingpong" style="width: 100%; height: 400px; position: absolute;left: -20px;"></div> -->
                            <pp-checkout id="payment-pingpong" style="width: 100%; height: 490px; position: absolute;" :accessToken="pingpongAccessToken" :locale="language"></pp-checkout>
                          </div>
                        </div>
                        <div class="long-margin" v-if="paymentOn === 'credit-card'">
                          <div id="creditPayment" style="max-height: 770px; width: 95%;margin-top: 15px;">
                            <div class="long-margin" style="margin-bottom:15px;">
                              <div class="msg-lastname" style="float:left;">
                                <div for="name" class="msg-name">{{$t('cardHolderLastName')}}：<span style="color:red;">*</span></div>
                                <div class="el-form-item__content">
                                  <div class="el-input">
                                    <input type="text" v-model="cardHolderLastName" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('cardHolderLastName')}" ref="cardHolderLastName" @blur="blurs('cardHolderLastName')" :placeholder="$t('lastName')">
                                  </div>
                                  <div class="el-form-item__error" v-show="getSomeThing('cardHolderLastName')">
                                    <span v-html="getLanguageHtml(cardHolderLastName,'cardHolderLastNameError')"></span>
                                  </div>
                                </div>
                              </div>
                              <div class="msg-username" style="margin-left:2%;">
                                <div for="name" class="msg-name">{{$t('cardHolderFirstName')}}：<span style="color:red;">*</span></div>
                                <div class="el-form-item__content">
                                  <div class="el-input">
                                    <input type="text" v-model="cardHolderFirstName" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('cardHolderFirstName')}" ref="cardHolderFirstName" @blur="blurs('cardHolderFirstName')" :placeholder="$t('firstName')">
                                  </div>
                                  <div class="el-form-item__error" v-show="getSomeThing('cardHolderFirstName')">
                                    <span v-html="getLanguageHtml(cardHolderFirstName,'cardHolderFirstNameError')"></span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="long-margin" style="margin-bottom:15px;">
                              <div class="msginfo-right">
                                <div for="name" class="msg-name">{{$t('creditBeditCardNumber')}}<span style="color:red;">*</span></div>
                                <div class="el-form-item__content" style="margin-bottom: 8px;">
                                  <div class="el-input">
                                    <input type="text" v-model="cardNo" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('cardno')}" ref="cardno" @input="formatCardNumber" @blur="blurs('cardno')" placeholder="0000 0000 0000 0000">
                                  </div>
                                  <div class="el-form-item__error" v-show="getSomeThing('cardno')">
                                    <span v-html="getLanguageHtml(cardNoError,'cardNoError')"></span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div style="margin-bottom:15px;">
                              <div class="msg-lastname" style="float:left;">
                                <div for="name" class="msg-name">{{$t('expiryDate')}}：<span style="color:red;">*</span></div>
                                <div class="el-form-item__content">
                                  <div class="el-input">
                                    <input type="text" autocomplete="off" v-model="effectivedate" class="el-input__inner" :class="{'codeError':getSomeThing('effectivedate')}" ref="effectivedate" @blur="blurs('effectivedate')" placeholder="MM/YY" @input="handleEffectiveDateInput">
                                  </div>
                                  <div class="el-form-item__error" v-show="getSomeThing('effectivedate')">
                                    <span v-html="getLanguageHtml(effectiveDateError,'effectiveDateError')"></span>
                                  </div>
                                </div>
                              </div>
                              <div class="msg-username" style="margin-left:2%;">
                                <div for="name" class="msg-name">{{$t('cvv')}}：<span style="color:red;">*</span></div>
                                <div class="el-form-item__content">
                                  <div class="el-input">
                                    <input type="text" v-model="cardVccTwo" autocomplete="off" class="el-input__inner cardRemindShow" :class="{'codeError': getSomeThing('securityCodeTwo')}" ref="securityCodeTwo" @blur="blurs('securityCodeTwo')" @click="showCardRemindInfoTwo">
                                  </div>
                                  <div class="el-form-item__error" v-show="getSomeThing('securityCodeTwo')">
                                    <span v-html="getLanguageHtml(securityCodeError,'securityCodeError')"></span>
                                  </div>
                                </div>
                                <div class="cardremind" v-show="showCardRemindTwo" style="position: absolute; z-index: 10000; box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px; background: white; width: 200px; height: 140px; border-radius: 5px; text-align: center; border: solid 1px #DCDFE6; padding-top: 10px;">
                                  <div class="remindimg">
                                    <img src="https://res.roompai.com/static/img/order/orderPay-CVV.svg" style="width:183px; height:114px;">
                                  </div>
                                  <div style="color:#4F4C4C; font-size:12px;margin-left: 6%;">3 {{$t('digitSecurityCode')}}</div>
                                </div>
                              </div>
                            </div>

                            <!-- 账单地址 -->
                            <div style="margin-top: 40px;font-size: 15px;font-weight: bold;">
                              <div>
                                <span> {{$t('billingAddress')}} </span>
                              </div>
                            </div>
                            <div class="long-margin" style="margin-bottom:15px;">
                              <div class="msg-lastname" :style="{ float: billingStateShow ? 'left' : ''}">
                                <div for="name" class="msg-name">{{$t('billingCountry')}}：<span style="color:red;">*</span></div>
                                <div class="el-form-item__content" style="margin-bottom: 8px;">
                                  <el-select v-model="billingCountry" filterable clearable style="width:100%;" :placeholder="$t('pleaseSelect')" :class="{'codeError':getSomeThing('billingCountry')}" ref="billingCountry" @change="blurs('billingCountry')">
                                    <el-option
                                      v-for="item in telOptions"
                                      :key="item.country"
                                      :label="item.country"
                                      :value="item.id">
                                    </el-option>
                                  </el-select>
                                  <div class="el-form-item__error" v-show="getSomeThing('billingCountry')" >
                                    <span v-html="getLanguageHtml(billingCountry,'billingCountryError')"></span>
                                  </div>
                                </div>
                              </div>
                              <div class="msg-username" v-show="billingStateShow" style="margin-left:2%;">
                                <div for="name" class="msg-name">{{$t('billingState')}}：<span style="color:red;">*</span></div>
                                <div class="el-form-item__content" style="margin-bottom: 8px;">
                                  <el-select v-model="billingState" filterable clearable style="width:100%;" :placeholder="$t('pleaseSelect')" :class="{'codeError':getSomeThing('billingState')}" ref="billingState" @change="blurs('billingState')">
                                    <el-option
                                      v-for="item in stateOptions[billingCountry]"
                                      :key="item.state"
                                      :label="item.state"
                                      :value="item.code">
                                    </el-option>
                                  </el-select>
                                  <div class="el-form-item__error" v-show="getSomeThing('billingState')" >
                                    <span v-html="getLanguageHtml(billingState,'billingStateError')"></span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="long-margin" style="margin-bottom:15px;">
                              <div class="msg-lastname" style="float:left;">
                                <div for="name" class="msg-name">{{$t('billingCity')}}：<span style="color:red;">*</span></div>
                                <div class="el-form-item__content">
                                  <div class="el-input">
                                    <input type="text" v-model="billingCity" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('billingCity')}" ref="billingCity" @blur="blurs('billingCity')" :placeholder="$t('billingCity')">
                                  </div>
                                  <div class="el-form-item__error" v-show="getSomeThing('billingCity')">
                                    <span v-html="getLanguageHtml(billingCity,'billingCityError')"></span>
                                  </div>
                                </div>
                              </div>
                              <div class="msg-username" style="margin-left:2%;">
                                <div for="name" class="msg-name">{{$t('billingAddress')}}：<span style="color:red;">*</span></div>
                                <div class="el-form-item__content" style="margin-bottom: 8px;">
                                  <div class="el-input">
                                    <input type="text" v-model="billingAddress" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('billingAddress')}" ref="billingAddress" @blur="blurs('billingAddress')" :placeholder="$t('billingAddress')">
                                  </div>
                                  <div class="el-form-item__error" v-show="getSomeThing('billingAddress')">
                                    <span v-html="getLanguageHtml(billingAddress,'billingAddressError')"></span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div style="margin-bottom:15px;">
                              <div class="msg-lastname" style="float:left;">
                                <div for="name" class="msg-name">{{$t('billingPostalCode')}}：<span style="color:red;">*</span></div>
                                <div class="el-form-item__content">
                                  <div class="el-input">
                                    <input type="text" v-model="billingPostalCode" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('billingPostalCode')}" ref="billingPostalCode" @blur="blurs('billingPostalCode')" :placeholder="$t('billingPostalCode')">
                                  </div>
                                  <div class="el-form-item__error" v-show="getSomeThing('billingPostalCode')">
                                    <span v-html="getLanguageHtml(billingPostalCode,'billingPostalCodeError')"></span>
                                  </div>
                                </div>
                              </div>

                              <div class="msg-username" style="margin-left:2%;">
                                <div for="name" class="msg-name">{{$t('billingapartmentRoom')}}</div>
                                <div class="el-form-item__content" style="margin-bottom: 8px;">
                                  <div class="el-input">
                                    <input type="text" v-model="billingapartmentRoom" autocomplete="off" class="el-input__inner" ref="billingapartmentRoom" :placeholder="$t('billingapartmentRoom')">
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-tab-pane>

                    <!-- 已存信用卡 -->
                    <el-tab-pane :label="$t('mySavedCards')" name="saveCard" v-if="payment_card_show && payment.total.status === '1'">
                      <div>
                        <img src="https://res.roompai.com/static/img/order/visa.png" style="width:38px; height:25px;" v-if="payment.total.typeLs.includes('visa')">
                        <img src="https://res.roompai.com/static/img/order/mastercard.png" style="width:38px; height:25px;" v-if="payment.total.typeLs.includes('master')">
                      </div>
                      <div>
                        <div class="long-margin">
                          <div class="msginfo-left">
                            <div for="name" class="msg-name">{{$t('creditBeditCardNumber')}}<span style="color:red;">*</span></div>
                            <div class="el-form-item__content">
                              <div class="el-input">
                                <el-select v-model="paymentCardno" placeholder="请选择" @change="changePaymentCardno(paymentCardno)" ref="paymentCardno" style="width:100%">
                                  <el-option v-for="item in payment.list" :key="item.sign" :label="item.cardno" :value="item.sign">
                                    <span style="float: left" v-if="item.type === 'visa'"><img src="https://res.roompai.com/static/img/order/visa.png" style="width:38px; height:25px;vertical-align: middle;margin-right: 10px;"></span>
                                    <span style="float: left" v-if="item.type === 'master'"><img src="https://res.roompai.com/static/img/order/mastercard.png" style="width:38px; height:25px;vertical-align: middle;margin-right: 10px;"></span>
                                    <span style="float: left;" v-html="item.cardno"></span>
                                  </el-option>
                                </el-select>
                              </div>
                            </div>
                          </div>
                          <div class="msginfo-right">
                            <div for="name" class="msg-name">{{$t('cardHolderName')}}<span style="color:red;">*</span></div>
                            <div class="el-form-item__content">
                              <div class="el-input is-disabled">
                                <input type="text" disabled="true" autocomplete="off" class="el-input__inner" :value="paymentCardnoName">
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style="padding-bottom:80px;">
                          <div class="msg-half-one">
                            <div for="name" class="msg-name">{{$t('expiryDate')}}<span style="color:red;">*</span></div>
                            <div class="el-form-item__content">
                              <div class="el-input is-disabled">
                                <input type="text" disabled="true" autocomplete="off" class="el-input__inner" :value="paymentCardnoEffectivedate">
                              </div>
                            </div>
                          </div>
                          <div class="msg-half">
                            <div for="name" class="msg-name">{{$t('cvv')}}<span style="color:red;">*</span></div>
                            <div class="el-form-item__content">
                              <div class="el-input">
                                <input type="text" v-model="cardVcc" autocomplete="off" class="el-input__inner cardRemindShow" :class="{'codeError':securityCodeShow}" ref="securityCode" @blur="blursCode('securityCode')" @click="showCardRemindInfo">
                              </div>
                              <div class="el-form-item__error" v-show="securityCodeShow">{{$t('validCVV')}}</div>
                            </div>
                          </div>
                          <div class="cardremind" v-show="showCardRemind">
                            <div class="remindimg">
                              <img src="https://res.roompai.com/static/img/order/orderPay-CVV.svg" style="width:183px; height:114px;">
                            </div>
                            <div style="color:#4F4C4C; font-size:12px;margin-left: 6%;">3 {{$t('digitSecurityCode')}}</div>
                          </div>
                        </div>
                      </div>
                    </el-tab-pane>
                    <!-- 信用卡/借记卡 -->
                    <el-tab-pane :label="$t('creditDebitCard')" name="newCard" v-if="payment_card_show">
                      <div>
                        <img src="https://res.roompai.com/static/img/order/visa.png" style="width:38px; height:25px;display:inline-block;">
                        <img src="https://res.roompai.com/static/img/order/mastercard.png" style="width:38px; height:25px;">
                      </div>
                      <div>
                        <div class="long-margin" style="margin-bottom:15px;">
                          <div class="msg-lastname" style="float:left;">
                            <div for="name" class="msg-name">{{$t('cardHolderLastName')}}：<span style="color:red;">*</span></div>
                            <div class="el-form-item__content">
                              <div class="el-input">
                                <input type="text" v-model="cardHolderLastName" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('cardHolderLastName')}" ref="cardHolderLastName" @blur="blurs('cardHolderLastName')">
                              </div>
                              <div class="el-form-item__error" v-show="getSomeThing('cardHolderLastName')">
                                <span v-html="getLanguageHtml(cardHolderLastName,'cardHolderLastNameError')"></span>
                              </div>
                            </div>
                          </div>
                          <div class="msg-username" style="margin-left:2%;">
                            <div for="name" class="msg-name">{{$t('cardHolderFirstName')}}：<span style="color:red;">*</span></div>
                            <div class="el-form-item__content">
                              <div class="el-input">
                                <input type="text" v-model="cardHolderFirstName" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('cardHolderFirstName')}" ref="cardHolderFirstName" @blur="blurs('cardHolderFirstName')">
                              </div>
                              <div class="el-form-item__error" v-show="getSomeThing('cardHolderFirstName')">
                                <span v-html="getLanguageHtml(cardHolderFirstName,'cardHolderFirstNameError')"></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="long-margin" style="margin-bottom:15px;">
                          <div class="msginfo-right">
                            <div for="name" class="msg-name">{{$t('creditBeditCardNumber')}}<span style="color:red;">*</span></div>
                            <div class="el-form-item__content" style="margin-bottom: 8px;">
                              <div class="el-input">
                                <input type="text" v-model="cardNo" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('cardno')}" ref="cardno" @input="formatCardNumber" @blur="blurs('cardno')">
                              </div>
                              <div class="el-form-item__error" v-show="getSomeThing('cardno')">
                                <span v-html="getLanguageHtml(cardNoError,'cardNoError')"></span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div style="margin-bottom:15px;">
                          <div class="msg-lastname" style="float:left;">
                            <div for="name" class="msg-name">{{$t('expiryDate')}}：<span style="color:red;">*</span></div>
                            <div class="el-form-item__content">
                              <div class="el-input">
                                <input type="text" autocomplete="off" v-model="effectivedate"  class="el-input__inner" placeholder="MM/YY" :class="{'codeError':getSomeThing('effectivedate')}" ref="effectivedate" @blur="blurs('effectivedate')">
                              </div>
                              <div class="el-form-item__error" v-show="getSomeThing('effectivedate')">
                                <span v-html="getLanguageHtml(effectiveDateError,'effectiveDateError')"></span>
                              </div>
                            </div>
                          </div>
                          <div class="msg-username" style="margin-left:2%;">
                            <div for="name" class="msg-name">{{$t('cvv')}}：<span style="color:red;">*</span></div>
                            <div class="el-form-item__content">
                              <div class="el-input">
                                <input type="text" v-model="cardVccTwo" autocomplete="off" class="el-input__inner cardRemindShow" :class="{'codeError': getSomeThing('securityCodeTwo')}" ref="securityCodeTwo" @blur="blurs('securityCodeTwo')" @click="showCardRemindInfoTwo">
                              </div>
                              <div class="el-form-item__error" v-show="getSomeThing('securityCodeTwo')">
                                <span v-html="getLanguageHtml(securityCodeError,'securityCodeError')"></span>
                              </div>
                            </div>
                            <div class="cardremind" v-show="showCardRemindTwo" style="position: absolute; z-index: 10000; box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px; background: white; width: 200px; height: 140px; border-radius: 5px; text-align: center; border: solid 1px #DCDFE6; padding-top: 10px;">
                              <div class="remindimg">
                                <img src="https://res.roompai.com/static/img/order/orderPay-CVV.svg" style="width:183px; height:114px;">
                              </div>
                              <div style="color:#4F4C4C; font-size:12px;margin-left: 6%;">3 {{$t('digitSecurityCode')}}</div>
                            </div>
                          </div>
                        </div>

                        <!-- 账单地址 -->
                        <div style="margin-top: 40px;font-size: 15px;font-weight: bold;">
                          <div>
                            <span> {{$t('billingAddress')}} </span>
                          </div>
                        </div>
                        <div class="long-margin" style="margin-bottom:15px;">
                          <div class="msg-lastname" style="float:left;">
                            <div for="name" class="msg-name">{{$t('billingCountry')}}<span style="color:red;">*</span></div>
                            <div class="el-form-item__content" style="margin-bottom: 8px;">
                              <el-select v-model="billingCountry" filterable clearable style="width:100%;" :placeholder="$t('pleaseSelect')" :class="{'codeError':getSomeThing('billingCountry')}" ref="billingCountry" @change="blurs('billingCountry')">
                                <el-option
                                  v-for="item in telOptions"
                                  :key="item.country"
                                  :label="item.country"
                                  :value="item.id">
                                </el-option>
                              </el-select>
                              <div class="el-form-item__error" v-show="getSomeThing('billingCountry')" >
                                <span v-html="getLanguageHtml(billingCountry,'billingCountryError')"></span>
                              </div>
                            </div>
                          </div>
                          <div class="msg-username" style="margin-left:2%;">
                            <div for="name" class="msg-name">{{$t('billingCity')}}：<span style="color:red;">*</span></div>
                            <div class="el-form-item__content">
                              <div class="el-input">
                                <input type="text" v-model="billingCity" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('billingCity')}" ref="billingCity" @blur="blurs('billingCity')">
                              </div>
                              <div class="el-form-item__error" v-show="getSomeThing('billingCity')">
                                <span v-html="getLanguageHtml(billingCity,'billingCityError')"></span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="long-margin" style="margin-bottom:15px;">
                          <div class="msginfo-right">
                            <div for="name" class="msg-name">{{$t('billingAddress')}}<span style="color:red;">*</span></div>
                            <div class="el-form-item__content" style="margin-bottom: 8px;">
                              <div class="el-input">
                                <input type="text" v-model="billingAddress" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('billingAddress')}" ref="billingAddress" @blur="blurs('billingAddress')">
                              </div>
                              <div class="el-form-item__error" v-show="getSomeThing('billingAddress')">
                                <span v-html="getLanguageHtml(billingAddress,'billingAddressError')"></span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div style="margin-bottom:15px;">
                          <div class="msg-lastname" style="float:left;">
                            <div for="name" class="msg-name">{{$t('billingPostalCode')}}：<span style="color:red;">*</span></div>
                            <div class="el-form-item__content">
                              <div class="el-input">
                                <input type="text" v-model="billingPostalCode" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('billingPostalCode')}" ref="billingPostalCode" @blur="blurs('billingPostalCode')">
                              </div>
                              <div class="el-form-item__error" v-show="getSomeThing('billingPostalCode')">
                                <span v-html="getLanguageHtml(billingPostalCode,'billingPostalCodeError')"></span>
                              </div>
                            </div>
                          </div>

                          <div class="msg-username" style="margin-left:2%;">
                            <div for="name" class="msg-name">{{$t('billingapartmentRoom')}}</div>
                            <div class="el-form-item__content" style="margin-bottom: 8px;">
                              <div class="el-input">
                                <input type="text" v-model="billingapartmentRoom" autocomplete="off" class="el-input__inner" ref="billingapartmentRoom">
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style="height:30px; margin-top: 20px; display: none">
                          <el-checkbox v-model="checked">{{$t('rememberCard')}}</el-checkbox>
                        </div>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </div>
            </form>
            <!--特殊要求-->
            <div class="msg-guest">
              <div style="padding: 2px 20px;">
                <p style="font-size:16px; font-weight:650;">{{$t('haveSpecialRequests')}}</p>
                <p style="font-size:14px;">{{$t('specialRequestsAreGuaranteed')}}</p>
                <p style="font-size:12px; color:rgb(83, 146, 249)">{{$t('placeEnterTexteEnglish')}}</p>
                <el-input type="textarea" placeholder="" v-model="special"  ref="specialRequirements"  @input="checkSpecial" maxlength="200" show-word-limit class="el-input__inner specialText"  v-if="language === 'en'"></el-input>
                <el-input type="textarea" placeholder="" v-model="special"  ref="specialRequirements" maxlength="200" show-word-limit class="el-input__inner specialText" v-else></el-input>
                </div>
            </div>
            <!--订房须知-->
            <div class="msg-guest" v-if="orderData.hotelFeesEnText !== ''">
              <div style="padding: 2px 20px;">
                <p style="font-size:16px; font-weight:650;">{{$t('bookingNotice')}}</p>
                <p style="font-size:14px;" class="hotelFeesText" v-if="language === 'en'" v-html="orderData.hotelFeesEnText"></p>
                <p style="font-size:14px;" class="hotelFeesText" v-if="language === 'zh'" v-html="orderData.hotelFeesZhText"></p>
              </div>
            </div>
            <!--去支付-->
            <div class="msg-guest" style="margin-bottom: 20px;">
              <div class="tonext">
                <p class="remind-font">
                  <span v-html="getLanguageHtml('','buttonMeansYouAgree')"></span>
                  <router-link :to="{name:'clause', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}" class="remind-text" target="_blank"> <span @click="linkClick('clause')">{{$t('termsOfUse')}}</span> </router-link> {{$t('and')}}
                  <router-link :to="{name:'policy', params: {'querys': common.linkEncode({'source': source, 'conver': conver}, 'obj')}}" class="remind-text" target="_blank"> <span @click="linkClick('policy')">{{$t('privacyPolicy')}}</span> </router-link>
                </p>
                <p style="font-size:12px; font-weight:500; color: #2F7000;height: 17px;line-height: 17px;" v-if="cancelData !== 0">
                  <img src="https://res.roompai.com/static/img/order/2F7000.png" style="width:17px; height:17px;vertical-align: text-bottom;">
                  {{$t('riskFree')}} <span v-html="getLanguageHtml(orderData.cancelData,'cancelData')"></span> {{$t('noCancelFeeBefore')}}
                </p>
                <p class="surplus-room" v-if="orderData.remainrooms === '1'">{{$t('onlyLast')}} 1 {{$t('onOurSite')}}</p>
                <OrderCancel v-if="showCancel === '1'" :source="source" :ismobile="ismobile" :noPayCancel="true"></OrderCancel>
                <el-button class="order_button" @click="JumpOver" v-if="orderData.order_status === '1'">{{$t('goPay')}}</el-button>
                <!-- wechat 弹出 30%-->
                <el-dialog :visible.sync="wechatEject"  width="450px" :show-close="wechatShowClose" class="tax-margin" top="10vh">
                  <div slot="title" style="text-align: left; font-size: 15px; color: #303133; font-weight:bold; border-bottom: 1px solid rgb(221, 223, 226); padding-bottom: 15px;">{{$t('completeWeatchPay')}}</div>
                  <div style="font-size: 12px; color: #303133; text-align: left; line-height: 24px;margin:-30px 0px -5px;overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;">
                    <div style="width: 100%;min-height: 30px;background: #F8F8FA;margin-bottom: 10px;color: #979797;">
                      <div style="width: 100%;height:30px;">
                        <div style="display: inline-block;width: 15%;text-align: right;float: left;">{{$t('roomName')}}</div>
                        <div style="display: inline-block;width: 75%;text-align: left;float: right;">
                          <span v-html="getLanguageHtml(orderData.roomName,'roomName')"></span>
                        </div>
                      </div>
                      <div style="width: 100%;height:30px;">
                        <div style="display: inline-block;width: 15%;text-align: right;float: left;">{{$t('checkInTime')}}</div>
                        <div style="display: inline-block;width: 75%;text-align: left;float: right;">
                          <span v-html="getLanguageHtml(orderData.checkin,'checkin')"></span>
                        </div>
                      </div>
                      <div style="width: 100%;height:30px;">
                        <div style="display: inline-block;width: 15%;text-align: right;float: left;">{{$t('checkOutTime')}}</div>
                        <div style="display: inline-block;width: 75%;text-align: left;float: right;">
                          <span v-html="getLanguageHtml(orderData.checkout,'checkout')"></span>
                        </div>
                      </div>
                      <div style="width: 100%;height:30px;">
                        <div style="display: inline-block;width: 15%;text-align: right;float: left;">{{$t('guest')}}</div>
                        <div style="display: inline-block;width: 75%;text-align: left;float: right;">
                          <span v-html="getLanguageHtml(orderData.person,'person')"></span>
                        </div>
                      </div>
                      <div style="width: 100%;height:30px;">
                        <div style="display: inline-block;width: 15%;text-align: right;float: left;">{{$t('totalPrice')}}</div>
                        <div style="display: inline-block;width: 75%;text-align: left;float: right;">
                          <span v-if="discountPrice === ''">{{orderData.totalPriceCNY}}</span>
                          <span v-else>{{orderData.discountTotalPriceCNY}}</span>
                        </div>
                      </div>
                    </div>
                    <div style="width: 100%;min-height: 210px;background: #F8F8FA;margin-bottom: 10px;color: #979797;">
                      <div style="width: 100%;height:30px;">
                        <div style="display: inline-block;width: 15%;text-align: right;float: left;">{{$t('step1')}}</div>
                        <div style="display: inline-block;width: 75%;text-align: left;float: right;">{{$t('useWechatToQecodePay')}}</div>
                      </div>
                      <div style="width: 100%;height:30px;text-align: center;">
                        <img :src="weChatImgUrl" alt="" style="width: 150px;">
                      </div>
                    </div>
                    <div style="width: 100%;min-height: 130px;background: #F8F8FA;margin-bottom: 10px;color: #979797;">
                      <div style="width: 100%;height:85px;">
                        <div style="display: inline-block;width: 15%;text-align: right;float: left;">{{$t('step2')}}</div>
                        <div style="display: inline-block;width: 75%;text-align: left;float: right;">
                          <span v-html="$t('accordingToPaymentResultSelect')"></span>
                        </div>
                      </div>
                      <div style="height: 50px;width: 100%;text-align: center;">
                        <el-button type="info" plain style="height: 35px;font-size: 12px;margin-right: 35px;" @click="wechatJumpOver"> {{$t('paymentHadProblems')}} </el-button>
                        <el-button type="primary" plain style="height: 35px;font-size: 12px;" @click="wechatJumpOver"> {{$t('paymentSpuccessful')}} </el-button>
                      </div>
                    </div>
                  </div>
                </el-dialog>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="main" v-else>
      <!--步骤条-->
      <div class="stepinfo" :style="{ width: `${elementWidth}px` }">
        <div :style="{ width: `${stepWidth}px`}" style="margin: auto;">
          <div  :style="{ width: `${lineWidth}px`, left: `${lineOneLeft}px` }" style="position:relative; top: 12.5px;">
            <i class="el-step__line-inner" style="transition-delay: 0ms; border-width: 0px; width: 100%;background-color: #4f4c4c;height: 1px;top: 14.5px;"></i>
          </div>
          <div  :style="{ width: `${lineWidth}px`, left: `${lineTwoLeft}px` }" style="position:relative; top:12.5px;">
            <i class="el-step__line-inner" style="transition-delay: 0ms; border-width: 0px; width: 100%;background-color: #4f4c4c;height: 1px;top: 14.5px;"></i>
          </div>
          <div :class="'order-step-new-'+language" style="float: left;">
            <div><img class="step-img" src="https://res.roompai.com/static/img/order/y-one.png"></div>
            <div><span class="step-text">{{$t('hoteInformation')}}</span></div>
          </div>
          <div :class="'order-step-new-'+language">
            <div><img class="step-img" src="https://res.roompai.com/static/img/order/y-two.png"></div>
            <div><span class="step-text">{{$t('customerInformation')}}</span></div>
          </div>
          <div :class="'order-step-new-'+language" style="float: right;">
            <div><img class="step-img" src="https://res.roompai.com/static/img/order/b-three.png"></div>
            <div><span class="step-text">{{$t('finalStep')}}</span></div>
          </div>
        </div>
      </div>
      <!--步骤条结束-->
      <div style="clear:both"></div>
      <div class="mobile-msg-main">
        <div>
          <!--登录/注册入口-->
          <div class="mobile-msg-blue" v-if="loginStatus">
            <div class="blue-tag">
              <div class='blue-back'>
                <img class="blue-logo" src="/static/img/order/pay-user.png">
              </div>
            </div>
            <div class="blue-text" style="height: 35px; line-height: 17.5px; margin: 7.5px 0px 7.5px 10px; float: left; overflow: hidden;">
              <span class="blue-maintext" @click="login">{{$t('signIn')}}/{{$t('createAccounts')}}</span>
              <span>{{$t('signingYourAccountBooking')}}</span>
            </div>
          </div>
          <div class="mobile-msg-blue" v-else>
            <div class="blue-tag">
              <div class='blue-back'>
                <img class="blue-logo" src="/static/img/order/pay-user.png">
              </div>
            </div>
            <div class="blue-text">
              <span style="float:left;">{{firstName}} {{$t('hello')}}</span>
              <span style="float:right; font-size: 12px;">
              </span>
            </div>
          </div>
          <!--倒计时-->
          <div class="msg-orange" :class="[{'msg-bule-show':loginStatus}]">
            <div class="orange-tag">
              <div class='orange-back'>
                <img class="orange-logo" src="/static/img/order/pay-hour.png">
              </div>
            </div>
            <div class="orange-text" style="height: 35px; line-height: 17.5px; margin: 7.5px 0px 7.5px 10px;float: left;">
              <div>{{$t('please')}}</div>
              <div class="orange-maintext" style="width:40px; text-align:center; ">{{minuteString + ':' + secondString}}</div>
              <span>{{$t('fillUpAllPriceDiff')}}</span>
            </div>
          </div>
        </div>
        <!--右侧部分-->
        <OrderRight :hotelOut="hotel" :orderDataOut="orderData" :source="source" :language="language" :ismobile="ismobile" :nowPageData="nowPageData" :paymentOn="paymentOn" :TransactionFeeshowOut="TransactionFeeshow"></OrderRight>
        <div class="msg-left">
          <!--住客资料-->
          <form class="el-form demo-ruleForm">
            <div class="msg-guest">
              <div class="advanceText">{{$t('customerInformationDesc')}}</div>
                <div style="padding: 10px 4.5% 0px 4.5%;">
                  <!--客房2 等等-->
                  <div v-for="(value, id) in customInfo" :key="id">
                    <div style="font-size:14px; font-weight:650;">{{$t('roomName')}} {{id + 1}}</div>
                    <div style="margin-bottom:20px;" v-if="language === 'zh'">
                      <div class="msg-lastname">
                        <div for="name" class="msg-name">{{$t('lastName')}}：<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input"><input type="text" class="el-input__inner" :value="value.lastname" disabled></div>
                        </div>
                      </div>
                      <div class="msg-username">
                        <div for="name" class="msg-name">{{$t('firstName')}}：<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <input type="text" class="el-input__inner" :value="value.firstname" disabled>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="margin-bottom:20px;" v-else>
                      <div class="msg-username">
                        <div for="name" class="msg-name">{{$t('firstName')}}：<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <input type="text" class="el-input__inner" :value="value.firstname" disabled>
                          </div>
                        </div>
                      </div>
                      <div class="msg-lastname">
                        <div for="name" class="msg-name">{{$t('lastName')}}：<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <input type="text" class="el-input__inner" :value="value.lastname" disabled>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="margin-bottom:20px;" v-if="id===0">
                      <div for="name" class="msg-name">{{$t('emailAddr')}}<span style="color:red;">*</span></div>
                      <div class="el-form-item__content">
                        <div class="el-input">
                          <input type="text" class="el-input__inner" :value="value.email" disabled>
                        </div>
                      </div>
                    </div>
                    <div style="margin-bottom:20px;">
                      <div class="msg-lastname" v-if="id===0">
                        <div for="name" class="msg-name">{{$t('phoneNumber')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input input-bor">
                            <el-select style="width:35%;" v-model="value.tel" :placeholder="$t('pleaseSelect')" disabled>
                              <el-option v-for="item in telOptions" :label="item.telnum" :key="item.id" :value="item.id">{{item.value}}</el-option>
                            </el-select>
                            <input style="width:63%;" type="text" class="el-input__inner" :value="value.phoneNum" disabled>
                          </div>
                        </div>
                      </div>
                      <div class="msg-username">
                        <div for="name" class="msg-name">{{$t('nationality')}}</div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <el-select style="width:100%;" v-model="value.nationality" filterable disabled>
                              <el-option v-for="item in telOptions" :key="item.id" :label="item.country" :value="item.id">{{item.country}}</el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
            <!--支付方式-->
            <div class="msg-right">
              <div class="advanceText">{{$t('payMethod')}}</div>
              <div class="advanceInfo">
                <div class="msg-green">
                  <div :class="'green-text-'+language">
                    <img class="green-logo" src="/static/img/order/dun.png">
                    <span style="font-size:12px;">{{$t('encryptedSecure')}}</span>
                  </div>
                </div>
                <div>
                  <img v-for="item in paymentMobileList" :key="item.value" :src="item.src" style="width:38px; height:25px; margin-right: 5px;">
                </div>
                <div>
                  <div class="long-margin" style="margin-bottom: 20px;">
                    <div>
                      <div for="name" class="msg-name">{{$t('payMethod')}}<span style="color:red;">*</span></div>
                      <div class="el-form-item__content">
                        <div class="el-input">
                          <el-select v-model="paymentOn" placeholder="请选择" @change="changePaymentMobile(paymentOn)" ref="paymentSelectMobile" class="paymentSelectMobile" style="width:100%">
                            <el-option v-for="item in paymentMobileList" :key="item.value" :label="getLanguageHtml(item,'paymentLabel')" :value="item.value" v-if="item.value !== 'saveCard' || (item.value === 'saveCard' && payment.total.status === '1')">
                              <span style="float: left"><img :src="item.src" style="width:38px; height:25px;vertical-align: middle;margin-right: 10px;"></span>
                              <span style="float: left;" v-html="getLanguageHtml(item,'paymentLabel')"></span>
                              <span style="float: right" v-if="['saveCard', 'newCard'].includes(item.value)">
                                  <img src="https://res.roompai.com/static/img/order/visa.png" style="width:38px; height:25px;vertical-align: middle; margin-left: 5px;" v-if="item.value === 'newCard' || (item.value === 'saveCard' && payment.total.typeLs.includes('visa'))">
                                  <img src="https://res.roompai.com/static/img/order/mastercard.png" style="width:38px; height:25px;vertical-align: middle; margin-left: 5px;" v-if="item.value === 'newCard' || (item.value === 'saveCard' && payment.total.typeLs.includes('master'))">
                                </span>
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="long-margin" v-show="['paypal', 'alipay', 'wechat', 'pingpong'].includes(paymentOn)">
                    <div style="min-height: 40px; margin-bottom: 10px;">
                      <div for="name" class="msg-name"></div>
                      <div class="el-form-item__content">
                        <li style="line-height: 25px;font-size: 12px;" v-if="['paypal', 'alipay'].includes(paymentOn)">{{$t('youSelectPay')}}<span v-html="getLanguageHtml(paymentOn,'paymentLabel')" style="font-weight: 400;color: #5392F9;"></span>{{$t('youWillBeForwardedTo')}}<span v-html="getLanguageHtml(paymentOn,'paymentLabel')" style="font-weight: 400;color: #5392F9;"></span>{{$t('websiteToProceedWithThisTransaction')}}</li>
                        <li style="line-height: 25px;font-size: 12px;" v-if="discountPrice === ''">
                          {{$t('theTotalAmountYouChanged')}}
                          <span style="font-weight: 400;color: #5392F9;" v-if="paymentOn === 'wechat'">{{orderData.totalPriceCNY}}</span>
                          <span style="font-weight: 400;color: #5392F9;" v-if="paymentOn === 'paypal' || paymentOn === 'pingpong'">
                            <a v-if="TransactionFeeshow === true && transactionFeeInfo && transactionFeeInfo[paymentOn]">{{transactionFeeInfo[paymentOn].totalPPriceUSD}}</a>
                            <a v-else>{{orderData.totalPriceUSD}}</a>
                          </span>
                          <span v-if="TransactionFeeshow === true && transactionFeeInfo && transactionFeeInfo[paymentOn]">
                            {{$t('TransactionFeeMsgFirst')}} {{transactionFeeInfo[paymentOn].TFeeTagUSD}} {{$t('TransactionFeeMsgLast')}}
                          </span>
                        </li>
                        <li style="line-height: 25px;font-size: 12px;" v-else>
                          {{$t('theTotalAmountYouChanged')}}
                          <span style="font-weight: 400;color: #5392F9;" v-if="paymentOn === 'wechat'">{{orderData.discountTotalPriceCNY}}</span>
                          <span style="font-weight: 400;color: #5392F9;" v-if="paymentOn === 'paypal' || paymentOn === 'pingpong'">
                            <a v-if="TransactionFeeshow === true">{{discountFeeInfo[paymentOn].discountTotalPriceUSD}}</a>
                            <a v-else>{{orderData.discountTotalPriceUSD}}</a>
                          </span>
                          <span v-if="TransactionFeeshow === true && discountFeeInfo && discountFeeInfo[paymentOn]">
                            {{$t('TransactionFeeMsgFirst')}} {{discountFeeInfo[paymentOn].discountTFeeTagUSD}} {{$t('TransactionFeeMsgLast')}}
                          </span>
                        </li>
                      </div>
                    </div>
                  </div>
                  <div class="long-margin" v-if="paymentOn === 'pingpong'">
                    <div id="creditPayment" style="position: relative; height: 770px; width: 100%;">
                      <!-- <div  id="payment-pingpong" style="width: 100%; height: 400px; position: absolute;left: -20px;"></div> -->
                      <pp-checkout id="payment-pingpong" style="width: 100%; height: 300px; position: absolute;" :accessToken="pingpongAccessToken" :locale="language"></pp-checkout>
                    </div>
                  </div>
                  <div class="long-margin" v-if="paymentOn === 'credit-card'" v-show="payment_card_show && payment.total.status === '1'">
                    <div class="long-margin">
                      <div class="msginfo-right">
                        <div for="name" class="msg-name">{{$t('creditBeditCardNumber')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <el-select v-model="paymentCardno" placeholder="请选择" @change="changePaymentCardnoMobile(paymentCardno)" ref="paymentCardnoMobile" class="paymentCardnoMobileClass" style="width:100%">
                              <el-option v-for="item in payment.list" :key="item.sign" :label="item.cardno" :value="item.sign">
                                <span style="float: left" v-if="item.type === 'visa'"><img src="https://res.roompai.com/static/img/order/visa.png" style="width:38px; height:25px;vertical-align: middle;margin-right: 10px;"></span>
                                <span style="float: left" v-if="item.type === 'master'"><img src="https://res.roompai.com/static/img/order/mastercard.png" style="width:38px; height:25px;vertical-align: middle;margin-right: 10px;"></span>
                                <span style="float: left;" v-html="item.cardno"></span>
                              </el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>
                      <div class="msginfo-left">
                        <div for="name" class="msg-name">{{$t('cardHolderName')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input is-disabled">
                            <input type="text" disabled="true" autocomplete="off" class="el-input__inner" :value="paymentCardnoName">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="padding-bottom:80px; position: relative;height: 20px;">
                      <div class="msg-half" style="width: 46%;position: absolute;">
                        <div for="name" class="msg-name">{{$t('expiryDate')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input is-disabled">
                            <input type="text" disabled="true" autocomplete="off" class="el-input__inner" :value="paymentCardnoEffectivedate">
                          </div>
                        </div>
                      </div>
                      <div class="msg-half" style="width: 46%;position: absolute;right: 0px;">
                        <div for="name" class="msg-name">{{$t('cvv')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <input type="text" autocomplete="off" class="el-input__inner cardRemindShow" :class="{'codeError':securityCodeShow}" ref="securityCode" @blur="blursCode('securityCode')" @click="showCardRemindInfo" @keyup.enter="closeCardRemind">
                          </div>
                          <div class="el-form-item__error" v-show="securityCodeShow">{{$t('validCVV')}}</div>
                        </div>
                      </div>
                      <div class="cardremind" v-show="showCardRemind">
                        <div class="remindimg">
                          <img src="https://res.roompai.com/static/img/order/orderPay-CVV.svg" style="width:183px; height:114px;">
                        </div>
                        <div style="color:#4F4C4C; font-size:12px;margin-left: 6%;">3 {{$t('digitSecurityCode')}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="long-margin" v-if="paymentOn === 'credit-card'">
                    <div class="long-margin">
                      <div class="msginfo-left">
                        <div for="name" class="msg-name">{{$t('cardHolderLastName')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <input type="text" v-model="cardHolderLastName" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('cardHolderLastName')}" ref="cardHolderLastName" @blur="blurs('cardHolderLastName')" :placeholder="$t('lastName')">
                          </div>
                          <div class="el-form-item__error" v-show="getSomeThing('cardHolderLastName')" style="position: unset;">
                            <span v-html="getLanguageHtml(cardHolderLastName,'cardHolderLastNameError')"></span>
                          </div>
                        </div>
                      </div>
                      <div class="msginfo-left">
                        <div for="name" class="msg-name">{{$t('cardHolderFirstName')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <input type="text" v-model="cardHolderFirstName" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('cardHolderFirstName')}" ref="cardHolderFirstName" @blur="blurs('cardHolderFirstName')" :placeholder="$t('firstName')">
                          </div>
                          <div class="el-form-item__error" v-show="getSomeThing('cardHolderFirstName')" style="position: unset;">
                            <span v-html="getLanguageHtml(cardHolderFirstName,'cardHolderFirstNameError')"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="long-margin">
                      <div class="msginfo-right">
                        <div for="name" class="msg-name">{{$t('creditBeditCardNumber')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <input type="text" v-model="cardNo" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('cardno'), 'paymentCardnoMobileClass': true}" ref="cardno" @input="formatCardNumber" @blur="blurs('cardno')" placeholder="0000 0000 0000 0000">
                          </div>
                          <div class="el-form-item__error" v-show="getSomeThing('cardno')" style="position: unset;">
                            <span v-html="getLanguageHtml(cardNoError,'cardNoError')"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="position: relative;">
                      <div class="msg-half">
                        <div for="name" class="msg-name">{{$t('expiryDate')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <input type="text" v-model="effectivedate" autocomplete="off" class="el-input__inner" placeholder="MM/YY" :class="{'codeError':getSomeThing('effectivedate')}" ref="effectivedate" @blur="blurs('effectivedate')" @input="handleEffectiveDateInput">
                          </div>
                          <div class="el-form-item__error" v-show="getSomeThing('effectivedate')" style="position: unset;">
                            <span v-html="getLanguageHtml(effectiveDateError,'effectiveDateError')"></span>
                          </div>
                        </div>
                      </div>
                      <div class="msg-half">
                        <div for="name" class="msg-name">{{$t('cvv')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <input type="text" v-model="cardVccTwo" autocomplete="off" class="el-input__inner cardRemindShow" :class="{'codeError':securityCodeShowTwo}" ref="securityCodeTwo" @blur="blurs('securityCodeTwo')" @click="showCardRemindInfoTwo" @keyup.enter="closeCardRemind">
                          </div>
                          <div class="el-form-item__error" v-show="getSomeThing('securityCodeTwo')" style="position: unset;">
                            <span v-html="getLanguageHtml(securityCodeError,'securityCodeError')"></span>
                          </div>
                        </div>
                      </div>
                      <div class="cardremind" v-show="showCardRemindTwo" style="position: relative; z-index:10000;">
                        <div class="remindimg" style="position: absolute;">
                          <img src="https://res.roompai.com/static/img/order/orderPay-CVV.svg" style="width:183px; height:114px;">
                        </div>
                        <div style="color:#4F4C4C; font-size:12px;margin-left: 6%;">3 {{$t('digitSecurityCode')}}</div>
                      </div>
                    </div>

                    <div style="margin-top: 40px;font-size: 15px;font-weight: bold;">
                      <div>
                        <span> {{$t('billingAddress')}} </span>
                      </div>
                    </div>
                    <!-- 账单地址 -->
                    <div style="position: relative;">
                      <div class="msg-half">
                        <div for="name" class="msg-name">{{$t('billingCountry')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content" style="margin-bottom: 8px;">
                          <el-select v-model="billingCountry" filterable clearable style="width:100%;" :placeholder="$t('pleaseSelect')" :class="{'codeError':getSomeThing('billingCountry')}" ref="billingCountry" @change="blurs('billingCountry')">
                            <el-option
                              v-for="item in telOptions"
                              :key="item.country"
                              :label="item.country"
                              :value="item.id">
                            </el-option>
                          </el-select>
                          <div class="el-form-item__error" v-show="getSomeThing('billingCountry')" >
                            <span v-html="getLanguageHtml(billingCountry,'billingCountryError')"></span>
                          </div>
                        </div>
                      </div>
                      <div class="msg-half" v-show="billingStateShow" style="margin-bottom:15px;">
                        <div for="name" class="msg-name">{{$t('billingState')}}：<span style="color:red;">*</span></div>
                        <div class="el-form-item__content" style="margin-bottom: 8px;">
                          <el-select v-model="billingState" filterable clearable style="width:100%;" :placeholder="$t('pleaseSelect')" :class="{'codeError':getSomeThing('billingState')}" ref="billingState" @change="blurs('billingState')">
                            <el-option
                              v-for="item in stateOptions[billingCountry]"
                              :key="item.state"
                              :label="item.state"
                              :value="item.code">
                            </el-option>
                          </el-select>
                          <div class="el-form-item__error" v-show="getSomeThing('billingState')" >
                            <span v-html="getLanguageHtml(billingState,'billingStateError')"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="long-margin" style="margin-bottom:15px;">
                      <div class="msg-half">
                        <div for="name" class="msg-name">{{$t('billingCity')}}：<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <input type="text" v-model="billingCity" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('billingCity')}" ref="billingCity" @blur="blurs('billingCity')">
                          </div>
                          <div class="el-form-item__error" v-show="getSomeThing('billingCity')">
                            <span v-html="getLanguageHtml(billingCity,'billingCityError')"></span>
                          </div>
                        </div>
                      </div>
                      <div class="msg-half" style="margin-bottom:15px;">
                        <div for="name" class="msg-name">{{$t('billingAddress')}}<span style="color:red;">*</span></div>
                        <div class="el-form-item__content" style="margin-bottom: 8px;">
                          <div class="el-input">
                            <input type="text" v-model="billingAddress" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('billingAddress')}" ref="billingAddress" @blur="blurs('billingAddress')">
                          </div>
                          <div class="el-form-item__error" v-show="getSomeThing('billingAddress')">
                            <span v-html="getLanguageHtml(billingAddress,'billingAddressError')"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div style="padding-bottom:40px;position: relative;">
                      <div class="msg-half" style="margin-bottom:15px;">
                        <div for="name" class="msg-name">{{$t('billingPostalCode')}}：<span style="color:red;">*</span></div>
                        <div class="el-form-item__content">
                          <div class="el-input">
                            <input type="text" v-model="billingPostalCode" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('billingPostalCode')}" ref="billingPostalCode" @blur="blurs('billingPostalCode')">
                          </div>
                          <div class="el-form-item__error" v-show="getSomeThing('billingPostalCode')">
                            <span v-html="getLanguageHtml(billingPostalCode,'billingPostalCodeError')"></span>
                          </div>
                        </div>
                      </div>
                      <div class="msg-half">
                        <div for="name" class="msg-name">{{$t('billingapartmentRoom')}}</div>
                        <div class="el-form-item__content" style="margin-bottom: 8px;">
                          <div class="el-input">
                            <input type="text" v-model="billingapartmentRoom" autocomplete="off" class="el-input__inner" ref="billingapartmentRoom">
                          </div>
                        </div>
                      </div>
                    </div>

                    <div style="height:30px; display: none">
                      <el-checkbox v-model="checked">{{$t('rememberCard')}}</el-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--特殊要求-->
            <div class="msg-guest">
              <div class="advanceText">{{$t('haveSpecialRequests')}}</div>
              <div style="padding: 10px 4.5% 0px 4.5%;">
                <p style="font-size:14px;">{{$t('specialRequestsAreGuaranteed')}}</p>
                <p style="font-size:12px; color:rgb(83, 146, 249)">{{$t('placeEnterTexteEnglish')}}</p>
                <el-input type="textarea" placeholder="" v-model="special"  ref="specialRequirements"  @input="checkSpecial" maxlength="200" show-word-limit class="el-input__inner specialText"  v-if="language === 'en'"></el-input>
                <el-input type="textarea" placeholder="" v-model="special"  ref="specialRequirements" maxlength="200" show-word-limit class="el-input__inner specialText"  v-else></el-input>
              </div>
            </div>
            <!--订房须知-->
            <div class="hotel-detail-info-mobile" v-if="orderData.hotelFeesEnText !== ''">
              <el-card class="box-card hotel-data-info">
                <div class="hotel-data-info-top" @click="mobileOverview = !mobileOverview">
                  <div class="hotel-overview-text">{{$t('bookingNotice')}}</div>
                  <div class="hotel-overview-img">
                    <img src="/static/img/hotelsearch/drop-down.png" alt="" v-if="mobileOverview === false">
                    <img src="/static/img/hotelsearch/drop-up.png" alt="" v-if="mobileOverview === true">
                  </div>
                </div>
                <div class="hotel-data-info-bottom" v-if="mobileOverview === true">
                  <p style="font-size:14px;" class="hotelFeesText" v-if="language === 'en'" v-html="orderData.hotelFeesEnText"></p>
                  <p style="font-size:14px;" class="hotelFeesText" v-if="language === 'zh'" v-html="orderData.hotelFeesZhText"></p>
                </div>
              </el-card>
            </div>
            <!--前往最后一步-->
            <div class="msg-guest" style="margin-bottom: 20px;">
              <div class="tonext">
                <p class="remind-font" v-if="language === 'en'"><span v-html="getLanguageHtml('','buttonMeansYouAgree')"></span><a class="remind-text" @click="linkClick('clause', '2')"> {{$t('termsUse')}}</a> {{$t('and')}} <a class="remind-text" @click="linkClick('policy', '2')">{{$t('privacyPolicy')}}</a></p>
                <p class="remind-font" v-else><span v-html="getLanguageHtml('','buttonMeansYouAgree')"></span><a class="remind-text" @click="linkClick('clause', '2')">{{$t('termsUse')}}</a>{{$t('and')}}<a class="remind-text" @click="linkClick('policy', '2')">{{$t('privacyPolicy')}}</a></p>
                <p style="font-size:12px; font-weight:500; color: #2F7000;line-height: 17px; margin-bottom: 5px;" v-if="cancelData !== 0">
                  <img src="https://res.roompai.com/static/img/order/2F7000.png" style="width:17px; height:17px;vertical-align: text-bottom;">{{$t('mobileRiskFreeOne')}}<br>
                  <span v-if="language === 'en'">{{$t('mobileRiskFreeTwo')}} </span>
                  <span v-else>{{$t('mobileRiskFreeTwo')}}</span>
                  <span v-html="getLanguageHtml(orderData.cancelData,'cancelData')"></span> {{$t('noCancelFeeBefore')}}
                </p>
                <p class="surplus-room" v-if="orderData.remainrooms === '1'">{{$t('onlyLast')}} 1 {{$t('onOurSite')}}!</p>
                <OrderCancel v-if="showCancel === '1'" :source="source" :ismobile="ismobile" :noPayCancel="true" :conver="conver"></OrderCancel>
                <el-button class="order_button" @click="JumpOver" v-if="orderData.order_status === '1'">{{$t('goPay')}}</el-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <frameRefresh :frameDialog="frameDialog"></frameRefresh>
    <frameHotelSold :frameHotelSoldDialog="frameHotelSoldDialog" :checkIn="checkIn" :checkOut="checkOut"></frameHotelSold>
    <frameHotelSoldEn :frameHotelSoldEnDialog="frameHotelSoldEnDialog" :checkIn="checkIn" :checkOut="checkOut"></frameHotelSoldEn>
    <frameHomeSold :frameHomeSoldDialog="frameHomeSoldDialog"></frameHomeSold>
    <frameRise :frameRiseDialog="frameRiseDialog" :risePrice="risePrice" :curPageData="curPageData" @frameRiseBookingFun="frameRiseBookingFun" @frameRiseBookingBackFun="frameRiseBookingBackFun"></frameRise>
    <frameQuotation :frameQuotationDialog="frameQuotationDialog"></frameQuotation>
    <frameLast :frameLastDialog="frameLastDialog" :homeSurplus="homeSurplus"></frameLast>
    <frameRemind :frameRemindDialog="frameRemindDialog" @continueBookingFun="continueBookingFun"></frameRemind>
    <frameToolong :frameToolongDialog="frameToolongDialog"></frameToolong>
    <frameNetwork :frameNetworkDialog="frameNetworkDialog"></frameNetwork>
    <frameNotice :frameNoticeDialog="frameNoticeDialog" @frameNoticeFun="frameNoticeFun"></frameNotice>
    <mobilepolicy :policyDialog="policyDialog" @getPolicyDia="getPolicyDia"></mobilepolicy>
    <mobileclause :clauseDialog="clauseDialog" @getClauseDia="getClauseDia"></mobileclause>
    <frameNoticePublic :frameNoticePublicShow="frameNoticePublicShow" :showNotice="frameNoticePublicShowText" @frameNoticePublicFun="frameNoticePublicFun"></frameNoticePublic>
    <publicMask :fullscreenLoading="fullscreenLoading"></publicMask>
    <framePaymentCustomizeFail :framePaymentCustomizeFailDialog="framePaymentCustomizeFailDialog" :framePaymentCustomizeText="framePaymentCustomizeText" @paymentCustomRetryClick="paymentCustomRetryClick"></framePaymentCustomizeFail>
    <framePaymentFail :framePaymentFailDialog="framePaymentFailDialog" @paymentRetryClick="paymentRetryClick"></framePaymentFail>
    <frameChangeRoom :frameChangeRoomDialog="frameChangeRoomDialog" :language="language" :sameRoomInfo="sameRoomInfo" :paymentOn="paymentOn" :curPageData="curPageData" @frameChangeRoomBookingFun="frameChangeRoomBookingFun" @frameChangeRoomBookingBackFun="frameChangeRoomBookingBackFun"></frameChangeRoom>
    <frameChangePriceAndRoom :frameChangePriceAndRoomDialog="frameChangePriceAndRoomDialog" :language="language" :sameRoomInfo="sameRoomInfo" :paymentOn="paymentOn" :curPageData="curPageData" :risePrice="risePrice" @frameChangePriceAndRoomBookingFun="frameChangePriceAndRoomBookingFun" @frameChangePriceAndRoomBookingBackFun="frameChangePriceAndRoomBookingBackFun"></frameChangePriceAndRoom>
  </el-main>
  <publicFooter></publicFooter>
</el-container>
</template>

<script>
import { writePayShow, orderBookVerify, writePayFinishBook, orderPayment, wechatJsPayGetSign } from '@/request/order.js'
import { signIn } from '@/request/login.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
import frameRefresh from '@/components/public/frameRefresh'
import frameHotelSold from '@/components/public/frameHotelSold'
import frameHotelSoldEn from '@/components/public/frameHotelSoldEn'
import frameHomeSold from '@/components/public/frameHomeSold'
import frameRise from '@/components/public/frameRise'
import frameQuotation from '@/components/public/frameQuotation'
import frameLast from '@/components/public/frameLast'
import frameRemind from '@/components/public/frameRemind'
import frameToolong from '@/components/public/frameToolong'
import frameNetwork from '@/components/public/frameNetwork'
import frameNotice from '@/components/public/frameNotice'
import frameNoticePublic from '@/components/public/frameNoticePublic'
import mobilepolicy from '@/components/question/mobilepolicy'
import mobileclause from '@/components/question/mobileclause'
import OrderRight from '@/components/order/module/OrderRight'
import OrderCancel from '@/components/order/module/OrderCancel'
import publicMask from '@/components/public/publicMask'
import framePaymentFail from '@/components/public/framePaymentFail'
import framePaymentCustomizeFail from '@/components/public/framePaymentCustomizeFail'
import frameChangeRoom from '@/components/public/frameChangeRoom'
import frameChangePriceAndRoom from '@/components/public/frameChangePriceAndRoom'

export default {
  name: 'writePay',
  components: {
    publicFooter,
    publicHeader,
    frameRefresh,
    frameHotelSold,
    frameHotelSoldEn,
    frameHomeSold,
    frameRise,
    frameQuotation,
    frameLast,
    frameRemind,
    frameToolong,
    frameNetwork,
    frameNotice,
    frameNoticePublic,
    mobilepolicy,
    mobileclause,
    OrderRight,
    OrderCancel,
    publicMask,
    framePaymentFail,
    framePaymentCustomizeFail,
    frameChangeRoom,
    frameChangePriceAndRoom
  },
  data () {
    return {
      curPageData: 'WritePay',
      nowPageData: 'bookingWritePay',
      hotelid: 0,
      hotel: {},
      orderData: {'roomName': {'zh': '', 'en': ''}, 'cancel': {'zh': '', 'en': ''}, 'night': {'zh': 1, 'en': 1}, 'roomNum': {'zh': 1, 'en': 1}, 'mandatoryFee': '', 'mandatoryTax': '', 'resortFee': '', 'payAtProperty': ''},
      customInfo: [],
      remainTime: 2400,
      guestRoomNum: 2,
      guestRoomMore: false,
      someArray: [],
      desc: '',
      telOptions: [{id: 216, value: '美国 +1', telnum: 'US +1'}, {id: 42, value: '中国 +0086', telnum: 'CN +86'}],
      stateOptions: {'36': [{id: 2}], '216': [{id: 20}]},
      billingStateShow: false,
      selectTel: '216',
      selectNat: {1: '216'},
      minute: '',
      second: '',
      promiseTimer: '',
      frameDialog: false, // 弹框1
      frameHotelSoldDialog: false, // 弹框2 中文
      frameHotelSoldEnDialog: false, // 弹框2 英文
      frameHomeSoldDialog: false, // 弹框3
      frameRiseDialog: false, // 弹框4
      frameQuotationDialog: false, // 弹框5
      frameLastDialog: false, // 弹框6
      frameRemindDialog: false, // 弹框7
      frameToolongDialog: false,
      frameNetworkDialog: false,
      frameNoticeDialog: false,
      risePrice: 12.5,
      homeSurplus: 3,
      screenWidth: 0,
      currencyShow: false, // 币种是否显示
      loginStatus: false,
      firstName: '',
      lastName: '',
      userEmail: '',
      cancelData: 0,
      pageRefresh: 0,
      pageVerifyNum: 1,
      pageVerifyTimer: '',
      orderWritePageTime: 300,
      language: this.common.languageSet(this),
      orderno: '',
      guestClicksRetry: 0,
      dateNumComplexStr: '',
      roomNumComplexStr: '',
      ismobile: false,
      taxWidth: 327,
      taxDia: false,
      commissionDia: false,
      taxShowClose: false,
      special: '',
      elementWidth: document.documentElement.clientWidth,
      stepWidth: document.documentElement.clientWidth - 20,
      lineWidth: 98,
      lineOneLeft: 48,
      lineTwoLeft: 196,
      policyDialog: false,
      clauseDialog: false,
      source: 'roompai',
      cardStatus: '',
      paymentSign: '',
      wechatH5Status: '',
      inputCursor: true, // 登录数据
      mobileOverview: false, // 订房须知
      cancelDia: false,
      cancelShowClose: false,
      canceltextZh: '',
      canceltextEn: '',
      mandatoryFeeDetail: false,
      payment: {'total': {'status': '0'}},
      payment_card_show: false,
      pingpong_card_data_load: false,
      paymentList: [{'value': 'paypal', 'label_zh': 'PayPal', 'label_en': 'PayPal', 'src': '/static/img/order/paypal.png'}, {'value': 'wechat', 'label_zh': '微信', 'label_en': 'WeChat', 'src': '/static/img/order/wechart.png'}, {'value': 'pingpong', 'label_zh': '借记卡/信用卡', 'label_en': 'Debit/credit card', 'src': '/static/img/order/debit-card.png'}],
      paymentMobileList: [{'value': 'paypal', 'label_zh': 'PayPal', 'label_en': 'PayPal', 'src': '/static/img/order/paypal.png'}, {'value': 'pingpong', 'label_zh': '借记卡/信用卡', 'label_en': 'Debit/credit card', 'src': '/static/img/order/debit-card.png'}],
      // paymentOn: 'paypal',
      paymentOn: this.common.linkQuerys.paymentOn,
      activeName: 'electronicPayment',
      paymentCardno: '0',
      paymentCardnoName: '',
      paymentCardnoEffectivedate: '',
      paymentCardnoValidCVV: '',
      checked: false,
      wechatEject: false,
      wechatShowClose: false,
      weChatImgUrl: '',
      showCancel: '0',
      securityCodeShow: false,
      showCardRemind: false,
      showCardRemindTwo: false,
      userNameError: 'appearsOnTheCard',
      cardNoError: 'validCardNumber',
      effectiveDateError: 'pleaseValidCardExpiry',
      securityCodeError: 'validCVV',
      cardUsername: '', // 卡信息
      cardNo: '', // 卡信息
      effectivedate: '', // 卡信息
      cardVcc: '', // 卡信息
      cardVccTwo: '', // 卡信息
      securityCodeShowTwo: false,
      frameNoticePublicShow: false,
      frameNoticePublicShowText: '',
      checkIn: '',
      checkOut: '',
      discountPrice: '',
      discountTotalPrice: 0,
      discountPayPrice: 0,
      discountTotalPriceCNY: '',
      discountTotalPriceUSD: '',
      TransactionFeeshow: false,
      fullscreenLoading: false, // loadding
      pingpongPayClient: '',
      framePaymentFailDialog: false, // 支付失败
      framePaymentCustomizeText: '', // 自定义支付结果
      framePaymentCustomizeFailDialog: false, // 自定义支付结果
      pingpongAccessToken: '',
      pingpongStatus: '', // pingpong 轮询状态
      transactionFeeInfo: {},
      discountFeeInfo: {},
      frameChangeRoomDialog: false, // 价格不变，房型变更弹框
      frameChangePriceAndRoomDialog: false, // 价格变更，房型变更
      sameRoomInfo: '',
      secureShieldJs: {}, // pingpong 在线安全支付的插件
      jsGeneratedData: {}, // 3Ds 返回的数据
      billingCountry: '', // 账单信息 国家
      billingState: '', // 账单信息 州
      billingCity: '', // 账单信息 城市
      billingAddress: '', // 账单信息 地址
      billingPostalCode: '', // 账单信息 邮政编码
      billingapartmentRoom: '', // 账单信息 省份
      cardHolderFirstName: '', // 持卡人 名称
      cardHolderLastName: '', // 持卡人 姓氏
      conver: '' // 是否网站挽回
    }
  },
  beforeCreate () {
  },
  created () {
    // 如果链接中没有 支付方式 则需要默认
    if (this.paymentOn === null || this.paymentOn === undefined) {
      this.paymentOn = 'paypal'
    }

    var params = this.$route.params
    var orderData = localStorage.getItem('orderData')
    if (JSON.stringify(params) === '{}' && orderData !== '{}') {
      params = JSON.parse(orderData)
    }
    var source = this.common.linkQuerys.source
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
    } else {
      this.source = params.source
    }

    var conver = this.common.linkQuerys.conver
    if (conver === 1 || conver === '1') {
      this.conver = conver
    } else {
      this.conver = (params && params.conver !== undefined) ? params.conver : ''
    }

    // 页面展示
    this.writePayPageShow()
    var width = document.documentElement.clientWidth
    this.taxWidth = width - 40
    if (this.common.languageSet(this) === 'zh') {
      this.lineWidth = (width - 164) / 2
      this.lineOneLeft = 48
      this.lineTwoLeft = this.lineWidth + 96
    } else {
      this.lineWidth = (width - 260) / 2 + 32 // (屏幕宽度 - 左右两侧间距20 - 步骤宽度80*3)/2 = 剩余横线宽度 + 左右延申宽度*2：(整体宽度80-图标25)/2 = 两侧宽度-11.5*2
      this.lineOneLeft = 64 // (整体宽度80-图标25)/2 = 两侧宽度 + 25 = 左侧+图标宽度 + 缝隙11.5
      this.lineTwoLeft = this.lineOneLeft + this.lineWidth + 48 // 第一条线偏移度 + 第一条线长度 + 缝隙11.5:和中文一致*2 + 图标宽度25
    }
  },
  mounted () {
    var that = this
    if (this.remainTime > 0) {
      this.minute = Math.floor((this.remainTime / 60) % 60)
      this.second = Math.floor(this.remainTime % 60)
      this.countDowm()
    }

    // 微信js支付 config获取签名
    var wechatJsPayConf = this.common.encryptionData([], this)
    if (wechatJsPayConf.ua.indexOf('MicroMessenger') !== -1) {
      this.wechatJsSign()
    }

    // 获取屏幕尺寸
    this.screenWidth = document.body.clientWidth
    window.onresize = () => {
      // 屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth
      })()
    }

    // 监听点击事件
    document.addEventListener('click', function (e) {
      var cardRemindShow = true
      for (var i = 0; i < e.target.classList.length; i++) {
        if (e.target.classList[i] === 'cardRemindShow') {
          cardRemindShow = false
        }
      }
      if (cardRemindShow) {
        that.showCardRemind = false
        that.showCardRemindTwo = false
      }
    })

    //  默认电子支付方式.
    // 保留支付方式
    var orderPaymentOn = sessionStorage.getItem('orderPaymentOn')
    if (orderPaymentOn !== null && orderPaymentOn !== undefined) {
      this.paymentOn = orderPaymentOn
    }
    if (location.host === 'us.roompai.com' || location.host === 'test.us.roompai.com') {
      if (this.common.isMobile()) {
        this.paymentMobileList = [{'value': 'paypal', 'label_zh': 'PayPal', 'label_en': 'PayPal', 'src': '/static/img/order/paypal.png'}, {'value': 'pingpong', 'label_zh': '借记卡/信用卡', 'label_en': 'Debit/credit card', 'src': '/static/img/order/debit-card.png'}]
      }
      if (this.source === 'sec') {
        this.paymentList = [{'value': 'paypal', 'label_zh': 'PayPal', 'label_en': 'PayPal', 'src': '/static/img/order/paypal.png'}, {'value': 'pingpong', 'label_zh': '借记卡/信用卡', 'label_en': 'Debit/credit card', 'src': '/static/img/order/debit-card.png'}]
        this.paymentMobileList = [{'value': 'paypal', 'label_zh': 'PayPal', 'label_en': 'PayPal', 'src': '/static/img/order/paypal.png'}, {'value': 'pingpong', 'label_zh': '借记卡/信用卡', 'label_en': 'Debit/credit card', 'src': '/static/img/order/debit-card.png'}]
      }
    } else {
      if (this.source === 'sec') {
        if (this.common.isMobile() === false) {
          this.paymentOn = 'wechat'
        }
        this.paymentList = [{'value': 'wechat', 'label_zh': '微信', 'label_en': 'WeChat', 'src': '/static/img/order/wechart.png'}]
        // this.paymentMobileList = [{'value': 'wechat', 'label_zh': '微信', 'label_en': 'WeChat', 'src': '/static/img/order/wechart.png'}]
      }
    }
    // 如果用户跳转参数中携带了paymentOn参数，则默认使用.
    if (['paypal', 'wechat', 'pingpong', 'credit-card'].includes(this.common.linkQuerys.paymentOn)) {
      this.paymentOn = this.common.linkQuerys.paymentOn
    }
    // 默认电子支付
    this.activeName = 'electronicPayment'
    if (this.common.isMobile() === false) {
      this.changePayment(this.paymentOn)
    } else {
      this.$nextTick(() => { that.changePaymentMobile(this.paymentOn) })
    }
    // 跳转到待支付页面，直接调起支付.
    if (this.common.linkQuerys.autoPay === 1 || this.common.linkQuerys.autoPay === '1') {
      this.JumpOver()
    }
    console.log('transactionFeeInfo[paymentOn]', this.paymentOn)
    setInterval(function () {
      if (that.payment.total.status === '1' && that.paymentCardno === '0') {
        for (let index in that.payment.list) {
          that.paymentCardno = that.payment.list[index].sign
          if (that.common.isMobile() === false) {
            that.changePaymentCardno(that.paymentCardno)
          } else {
            that.$nextTick(() => { that.changePaymentCardnoMobile(that.paymentCardno) })
          }
          return false
        }
      }
    }, 1000)

    // 如果是微信 授权登录成功，则直接调起支付
    var payOrder = this.common.linkQuerys.payOrder
    if (payOrder === 'now') {
      this.paymentOn = 'wechat'
      this.JumpOver()
    }

    // 微信支付 切换回来 要
    document.addEventListener('visibilitychange', this.handleVisibilityChange)

    // // PingPong 支付样式增加
    // window.addEventListener('load', this.pingpongPaymentWrap)
  },
  watch: {
    screenWidth: function (n, o) {
      if (n <= 1000) {
        this.ismobile = true
      } else {
        this.ismobile = false
      }
    },
    pageVerifyNum: function (news, olds) {
      if (news > 3) {
        this.framePaymentFailDialog = false
        this.frameRemindDialog = true
        this.frameDialog = false
        this.frameHotelSoldDialog = false
        this.frameHotelSoldEnDialog = false
        this.frameHomeSoldDialog = false
        this.frameRiseDialog = false
        this.frameQuotationDialog = false
        this.frameLastDialog = false
        this.frameToolongDialog = false
        this.frameNetworkDialog = false
        this.frameNoticeDialog = false
        this.frameChangeRoomDialog = false
        this.frameChangePriceAndRoomDialog = false

        // 结束定时器
        clearInterval(this.pageVerifyTimer)
      } else {
        this.pageRefresh = 0
        this.framePaymentFailDialog = false
        this.frameQuotationDialog = true
        this.orderVerify()
      }
    },
    language: function (newCur, oldCur) {
      this.writePayPageShow()
    },
    $route: function (to, from) {
      // console.log(to, from)
    },
    paymentOn: function (to, form) {
      if (['paypal', 'pingpong'].includes(this.paymentOn) && this.transactionFeeInfo !== '' && this.source === 'sec') {
        this.TransactionFeeshow = true
      } else {
        this.TransactionFeeshow = false
      }
      if (to === 'pingpong' || to === 'credit-card') {
        this.writePayPageShow()
      }
    },
    pingpong_card_data_load: function (to, form) {
      console.log(to, form)
      // pingpong 请求
      if (to) {
        // pingpong 的 特殊逻辑
        // 支付过程中的风险控制插件
        var options = {
          env: this.orderData.pay_card_env,
          accId: this.orderData.pay_card_accId,
          clientId: this.orderData.pay_card_clientId,
          requestId: this.orderData.pay_card_orderno,
          merchantUserId: this.orderData.pay_card_userId
        }
        window.SafePayGuardJs.init(options)

        // 在线安全支付的插件
        var optionShields = {
          env: this.orderData.pay_card_env,
          accId: this.orderData.pay_card_accId,
          clientId: this.orderData.pay_card_clientId,
          requestId: this.orderData.pay_card_orderno,
          merchantUserId: this.orderData.pay_card_userId,
          merchantTransactionId: this.orderData.pay_card_orderno
        }
        this.secureShieldJs = window.SecureShieldJs.init(optionShields)
      }
    },
    billingCountry: function (to, form) {
      if (to === '36' || to === '216') {
        this.billingStateShow = true
      } else {
        this.billingStateShow = false
      }
    }
  },
  beforeDestroy () {
  },
  methods: {
    formatCardNumber (e) {
      const input = e.target
      const cursorIndex = input.selectionStart
      const lineNumOfCursorLeft = (e.target.value.slice(0, cursorIndex).match(/\s/g) || []).length
      const noLine = e.target.value.replace(/\s/g, '')
      const newCardNum = noLine.replace(/\D+/g, '').replace(/(\d{4})/g, '$1 ').replace(/\s$/, '')
      const newLineNumOfCursorLeft = (newCardNum.slice(0, cursorIndex).match(/\s/g) || []).length
      const newCursorIndex = cursorIndex + newLineNumOfCursorLeft - lineNumOfCursorLeft
      this.$nextTick(() => {
        this.cardNo = newCardNum
        this.$nextTick(() => {
          input.selectionStart = newCursorIndex
          input.selectionEnd = newCursorIndex
        })
      })
    },
    hotelLanguage (language) {
      this.language = language
    },
    getfirstName (firstName) {
      this.firstName = firstName
    },
    checkSpecial () {
      this.special = this.special.replace(/[\u4e00-\u9fa5/]|[^a-zA-Z0-9\u4E00-\u9FA5\s+,.!-?:;()/]/g, '')
    },
    writePayPageShow: function () {
      var that = this
      let locationHref = window.document.location.href
      var orderno = this.common.linkQuerys.orderno
      var params = this.$route.params
      var orderData = localStorage.getItem('orderData')
      if (JSON.stringify(params) === '{}' && orderData !== '{}') {
        params = JSON.parse(orderData)
        if (orderno === undefined) {
          orderno = params.orderno
        }
      }
      if (params === null) {
        params = JSON.parse('{}')
      }
      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      this.checkIn = params.checkin
      this.checkOut = params.checkout
      var currency = this.common.currencySet(this)
      var time = parseInt(new Date().getTime() / 1000)
      var requestTime = parseInt(new Date().getTime())
      var sessionid = this.common.sessionidGet(this)
      var initUrl = sessionStorage.getItem('roompaiAccessLink')
      if (initUrl === undefined || initUrl === null) {
        initUrl = ''
      }

      // 订单信息填写数据
      var orderDataJson = {
        'token': token,
        'hotelid': params.hotelid,
        'checkin': params.checkin,
        'checkout': params.checkout,
        'room': params.room,
        'adult': params.adult,
        'child': params.child,
        'childNums': params.childNums !== undefined ? params.childNums : '',
        'product': params.product,
        'time': time,
        'source': this.source,
        'orderno': orderno,
        'currency': currency,
        'paymentOn': this.paymentOn,
        'sessionid': sessionid,
        'language': this.language,
        'initUrl': initUrl,
        'operation': 'writePayShow'
      }
      var orderDataShow = this.common.encryptionData(orderDataJson, this)
      writePayShow(orderDataShow).then(res => {
        if (res.flag === '001') {
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          if (this.conver === 1 || this.conver === '1') {
            newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
          }
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else {
          // console.log(res)
          this.orderData = res.data.orderData
          this.transactionFeeInfo = this.orderData.transactionFeeInfo
          this.discountFeeInfo = this.orderData.discountTFeeInfo
          // 如果订单已经微信支付，需要跳转到订单结果页面
          if (res.data.orderData.wechat_pay_status === 1) {
            this.wechatJumpOver()
          }

          // 其他情况
          if (res.data.orderData.orderPayPageTime !== 0) {
            this.orderPayPageTime = res.data.orderData.orderPayPageTime
          }
          if (res.data.orderData.createtime !== 0) {
            var dateTime = (parseInt(new Date().getTime() / 1000) - res.data.orderData.createtime)
            if (dateTime <= this.orderPayPageTime) {
              this.remainTime = this.orderPayPageTime - dateTime
            } else {
              this.remainTime = 0
            }
            this.minute = Math.floor((this.remainTime / 60) % 60)
            this.second = Math.floor(this.remainTime % 60)
          }
          // 信息
          this.hotel = res.data.hotel
          this.loginStatus = res.data.orderData.loginStatus
          this.firstName = res.data.orderData.firstname
          this.lastName = res.data.orderData.lastname
          this.userEmail = res.data.orderData.useremail
          this.cancelData = res.data.orderData.cancelData.en
          this.telOptions = res.data.countryCode
          this.stateOptions = res.data.stateCode // 州下拉
          this.homeSurplus = res.data.orderData.remainrooms
          this.special = res.data.orderData.special_request
          this.customInfo = res.data.orderData.custom_info
          this.canceltextZh = this.orderData.canceltext.zh
          this.canceltextEn = this.orderData.canceltext.en
          if (this.orderData.discount !== '') {
            this.discountPrice = this.orderData.discount
            this.discountTotalPrice = this.orderData.discountTotalPrice
            this.discountPayPrice = this.orderData.discountPayPrice
            this.discountTotalPriceCNY = this.orderData.discountTotalPriceCNY
            this.discountTotalPriceUSD = this.orderData.discountTotalPriceUSD
          }
          this.payment = res.data.payment
          // 支付方式
          // 处理支付方式逻辑.
          if (this.orderData.paymentConfig !== null && this.orderData.paymentConfig !== undefined) {
            // web.
            this.paymentList = this.orderData.paymentConfig.paymentList.list
            // mobile
            this.paymentMobileList = this.orderData.paymentConfig.paymentMobileList.list
          }
          if (res.data.orderData.pay_way !== '') {
            this.paymentOn = res.data.orderData.pay_way
          }
          if (['paypal', 'pingpong'].includes(this.paymentOn) && this.transactionFeeInfo !== '' && this.source === 'sec') {
            this.TransactionFeeshow = true
          }
          if (this.common.isMobile() === false) {
            this.changePayment(this.paymentOn)
          } else {
            this.changePaymentMobile(this.paymentOn)
          }

          this.activeName = 'electronicPayment'
          if (this.paymentOn === 'credit-card') {
            this.pingpong_card_data_load = true
          }

          // 是否显示取消按钮.
          that.showCancel = res.data.orderData.order_status === '1' && (this.common.linkQuerys.showCancel === 1 || this.common.linkQuerys.showCancel === '1') ? '1' : '0'
          // pingpong 支付加载
          that.pingpongPaymentWrap()

          // pingpong 支付
          if (res.data.orderData.pingpong_pay_status !== 0 && res.data.orderData.pingpong_pay_status !== '0') {
            this.pingpongJumpOver()
          }
          if (res.data.orderData.card_pay_status !== 0 && res.data.orderData.card_pay_status !== '0') {
            this.paymentSign = res.data.orderData.paymentSign
            this.cardJumpOver()
          }
        }
        return res
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(orderDataShow, res, requestTime, responseTime)
        })
      })
    },
    getLanguageHtml: function (data, type) {
      if (data === undefined) {
        return ''
      }
      var getLanguage = this.common.languageSet(this)
      if (['hotelname', 'hoteladdress'].includes(type)) {
        var typeLan = type + '_' + getLanguage
        return data[typeLan]
      } else if (['roomName', 'checkin', 'checkout', 'night', 'roomNum', 'person', 'child', 'bedType', 'breakfast', 'cancel', 'cancelData'].includes(type)) {
        if (getLanguage === 'zh') {
          return data.zh
        } else {
          return data.en
        }
      } else if (['userLastNameError', 'userNameError', 'emailError', 'telError', 'emailConfirmError', 'cardNoError', 'effectiveDateError', 'securityCodeError', 'emailError', 'telError', 'emailConfirmError', 'paymentLabelShow'].includes(type)) {
        return this.$t(data)
      } else if (['paymentLabel'].includes(type)) {
        if (getLanguage === 'zh') {
          return data.label_zh
        } else {
          return data.label_en
        }
      } else if (['buttonMeansYouAgree', 'billingCountryError', 'billingStateError', 'billingCityError', 'billingAddressError', 'billingPostalCodeError', 'cardHolderFirstNameError', 'cardHolderLastNameError'].includes(type)) {
        return this.$t(type)
      }
    },
    blurs (refInfo) {
      var refName = this.$refs[refInfo].value
      if (['billingCountry'].includes(refInfo)) {
        refName = this.billingCountry
      }
      if (['billingState'].includes(refInfo)) {
        refName = this.billingState
      }
      if (refName === '' || refName === null) {
        this.$set(this.someArray, refInfo, true)
      } else {
        this.$set(this.someArray, refInfo, false)
        /*
        if ([,'billingCountry', 'billingCity', 'billingAddress', 'billingPostalCode'].includes(refInfo)) {
          this.$set(this.someArray, refInfo, false)
        }
        */
        if (['securityCodeTwo'].includes(refInfo)) {
          if (refName.length >= 4) {
            this.$set(this.someArray, refInfo, true)
            return false
          }
        }

        if (['effectivedate'].includes(refInfo)) {
          if (refName.length !== 5 || !refName.includes('/')) {
            this.$set(this.someArray, refInfo, true)
            return false
          }

          var refDateMonth = refName.slice(0, 2)
          var refDateYear = refName.slice(3, 5)

          var curDate = new Date()
          var curYear = curDate.getFullYear().toString().substr(-2)
          var curMonth = curDate.getMonth() + 1
          if (refDateMonth < 1 || refDateMonth > 12) {
            console.log('年月1')
            this.$set(this.someArray, refInfo, true)
            return false
          }
          if (refDateYear === curYear && refDateMonth < curMonth) {
            console.log('年月2')
            this.$set(this.someArray, refInfo, true)
            return false
          }
          if (refDateYear < curYear) {
            console.log('年月3')
            this.$set(this.someArray, refInfo, true)
            return false
          }
        }
      }

      if (['cardno', 'effectivedate'].includes(refInfo)) {
        this.handleBlur(refInfo)
      }

      this.frameRiseDialog = false
      this.frameChangeRoomDialog = false
      this.frameChangePriceAndRoomDialog = false
    },
    getSomeThing (index) { // 返回数组元素
      return this.someArray[index]
    },
    showCardRemindInfo () {
      this.showCardRemind = true
    },
    showCardRemindInfoTwo () {
      this.showCardRemindTwo = true
    },

    // pingpong 卡支付 需要提前js逻辑
    // 代理函数，在3Ds init前对参数进行校验
    proxyThreeDsParams: function () {
      const self = this
      return new Proxy({
        cardNumber: self.cardNo,
        expireDate: self.effectivedate
      }, {
        get: (target, key) => {
          // 简单校验：卡号位数 <= 15时返回空字符
          if (key === 'cardNumber') {
            return target[key].length <= 15 ? '' : target[key].replace(/\s+/g, '')
          }

          // 卡号有效期参数处理：不满足条件返回空字符，反之为处理好的参数格式
          if (key === 'expireDate') {
            const expireDate = target[key].replace(/\s+/g, '')

            if (expireDate.length === 5 && expireDate.indexOf('/') > -1) {
              const [cardExpireMonth, cardExpireYear] = expireDate.split('/')

              return {
                cardExpireMonth,
                cardExpireYear: `20${cardExpireYear}`
              }
            }
            return ''
          }
          return ''
        }
      })
    },
    getThreeDsInitParams: function (threeDsParams) {
      const { cardNumber, expireDate } = threeDsParams

      if (!cardNumber) return null

      if (typeof expireDate === 'string') return null

      const { cardExpireMonth, cardExpireYear } = expireDate

      return {
        cardNumber,
        cardExpireMonth,
        cardExpireYear
      }
    },
    handleBlur: function (name) {
      const _proxyThreeDsParams = this.proxyThreeDsParams()
      const params = this.getThreeDsInitParams(_proxyThreeDsParams)
      // 当校验不通过时，你不需要调用triggerThreeDsInit方法
      if (params) {
        this.secureShieldJs.triggerThreeDsInit(params).then((data) => {
          this.jsGeneratedData = data
        })
      }
    },

    // 点击支付按钮操作
    JumpOver: function () {
      // 增加 loading
      this.fullscreenLoading = true

      // 历史信息
      var params = this.$route.params
      var orderno = this.common.linkQuerys.orderno
      var orderData = localStorage.getItem('orderData')
      if (JSON.stringify(params) === '{}' && orderData !== '{}') {
        params = JSON.parse(orderData)
        if (orderno === undefined) {
          orderno = params.orderno
        }
      }

      // 点击支付订单 后关闭下次点击
      if (this.payOrdernoClick === true) {
        // 如果微信PC支付 则 需要弹框
        if (this.paymentOn === 'wechat' && this.weChatImgUrl !== '') {
          this.wechatEject = true
        }
        this.fullscreenLoading = false
        return false
      }
      this.payOrdernoClick = true

      // 防止重复点击一分钟后 可以点击
      setTimeout(() => {
        this.payOrdernoClick = false
      }, 5000)

      this.showCardRemind = false
      this.showCardRemindTwo = false
      var language = this.common.languageSet(this)
      let locationHref = window.document.location.href

      var activeNameOver = 'newCard'
      if (!['credit-card'].includes(this.paymentOn)) {
        activeNameOver = 'electronicPayment'
      }

      var securityCode = this.cardVcc
      var cardno = this.cardNo
      var effectivedate = this.effectivedate
      var securityCodeTwo = this.cardVccTwo
      var username = this.cardUsername
      var cardHolderLastName = this.cardHolderLastName
      var cardHolderFirstName = this.cardHolderFirstName
      // 账单信息
      var billingCountry = this.billingCountry
      var billingState = this.billingState
      var billingAddress = this.billingAddress
      var billingPostalCode = this.billingPostalCode
      var billingCity = this.billingCity
      var billingapartmentRoom = this.billingapartmentRoom

      if (['saveCard', 'newCard'].includes(activeNameOver)) {
        if (activeNameOver === 'saveCard') {
          this.$options.methods.blursCode.bind(this)('securityCode')
          if (this.securityCodeShow === true) {
            this.$refs['securityCode'].focus()
            this.fullscreenLoading = false
            return false
          }
        } else if (activeNameOver === 'newCard') {
          // this.$options.methods.blurs.bind(this)('username')
          // let usernameError = this.$options.methods.getSomeThing.bind(this)('username')
          // if (usernameError === true) {
          //   this.$refs['username'].focus()
          //   this.fullscreenLoading = false
          //   return false
          // }

          this.$options.methods.blurs.bind(this)('cardHolderLastName')
          let cardHolderLastNameError = this.$options.methods.getSomeThing.bind(this)('cardHolderLastName')
          if (cardHolderLastNameError === true) {
            this.$refs['cardHolderLastName'].focus()
            this.fullscreenLoading = false
            return false
          }
          this.$options.methods.blurs.bind(this)('cardHolderFirstName')
          let cardHolderFirstNameError = this.$options.methods.getSomeThing.bind(this)('cardHolderFirstName')
          if (cardHolderFirstNameError === true) {
            this.$refs['cardHolderFirstName'].focus()
            this.fullscreenLoading = false
            return false
          }

          this.$options.methods.blurs.bind(this)('cardno')
          let cardnoError = this.$options.methods.getSomeThing.bind(this)('cardno')
          if (cardnoError === true) {
            this.$refs['cardno'].focus()
            this.fullscreenLoading = false
            return false
          }
          this.$options.methods.blurs.bind(this)('effectivedate')
          let effectivedateError = this.$options.methods.getSomeThing.bind(this)('effectivedate')
          if (effectivedateError === true) {
            this.$refs['effectivedate'].focus()
            this.fullscreenLoading = false
            return false
          }
          this.$options.methods.blurs.bind(this)('securityCodeTwo')
          let securityCodeTwoError = this.$options.methods.getSomeThing.bind(this)('securityCodeTwo')
          if (securityCodeTwoError === true) {
            this.$refs['securityCodeTwo'].focus()
            this.fullscreenLoading = false
            return false
          }

          // 账单信息
          this.$options.methods.blurs.bind(this)('billingCountry')
          let billingCountryError = this.$options.methods.getSomeThing.bind(this)('billingCountry')
          if (billingCountryError === true) {
            this.$refs['billingCountry'].focus()
            this.fullscreenLoading = false
            return false
          }
          // console.log(billingCountry)
          // 州判断
          if (billingCountry === '36' || billingCountry === '216') {
            this.$options.methods.blurs.bind(this)('billingState')
            let billingStateError = this.$options.methods.getSomeThing.bind(this)('billingState')
            // console.log(billingStateError)
            if (billingStateError === true) {
              this.$refs['billingState'].focus()
              this.fullscreenLoading = false
              return false
            }
          }
          this.$options.methods.blurs.bind(this)('billingCity')
          let billingCityError = this.$options.methods.getSomeThing.bind(this)('billingCity')
          if (billingCityError === true) {
            this.$refs['billingCity'].focus()
            this.fullscreenLoading = false
            return false
          }
          this.$options.methods.blurs.bind(this)('billingAddress')
          let billingAddressError = this.$options.methods.getSomeThing.bind(this)('billingAddress')
          // console.log(billingAddressError)
          if (billingAddressError === true) {
            this.$refs['billingAddress'].focus()
            this.fullscreenLoading = false
            return false
          }
          this.$options.methods.blurs.bind(this)('billingPostalCode')
          let billingPostalCodeError = this.$options.methods.getSomeThing.bind(this)('billingPostalCode')
          if (billingPostalCodeError === true) {
            this.$refs['billingPostalCode'].focus()
            this.fullscreenLoading = false
            return false
          }

          // 支付信息
          if (cardno.length >= 20) {
            this.$refs['cardno'].focus()
            this.fullscreenLoading = false
            return false
          }
          if (effectivedate.length !== 5 || !effectivedate.includes('/')) {
            this.$refs['effectivedate'].focus()
            this.fullscreenLoading = false
            return false
          }
          if (securityCodeTwo.length >= 4) {
            this.$refs['securityCodeTwo'].focus()
            this.fullscreenLoading = false
            return false
          }
        }
      }

      var generatedPayData = {}
      var generatedShieldData = {}
      var acName = activeNameOver
      if (this.paymentOn === 'credit-card') {
        generatedPayData = window.SafePayGuardJs.getGeneratedData()
        generatedShieldData = this.secureShieldJs.getGeneratedData()
        if (!generatedShieldData.hasOwnProperty('jsGeneratedData')) {
          generatedShieldData['jsGeneratedData'] = this.jsGeneratedData
        }
        acName = 'newCard'
      }

      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }

      var currency = this.common.currencySet(this)
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)
      var initUrl = sessionStorage.getItem('roompaiAccessLink')
      if (initUrl === undefined || initUrl === null) {
        initUrl = ''
      }

      // 订单信息填写数据
      var orderFinishBookJson = {
        'token': token,
        'activeName': acName,
        'securityCode': securityCode,
        'username': username,
        'cardHolderLastName': cardHolderLastName,
        'cardHolderFirstName': cardHolderFirstName,
        'cardno': cardno,
        'effectivedate': effectivedate,
        'securityCodeTwo': securityCodeTwo,
        'paymentInfo': this.paymentCardno,
        'billingCountry': billingCountry,
        'billingState': billingState,
        'billingAddress': billingAddress,
        'billingPostalCode': billingPostalCode,
        'billingCity': billingCity,
        'billingapartmentRoom': billingapartmentRoom,
        'hotelid': params.hotelid || '',
        'checkin': params.checkin,
        'checkout': params.checkout,
        'room': params.room,
        'adult': params.adult,
        'child': params.child,
        'childNums': params.childNums !== undefined ? params.childNums : '',
        'product': params.product,
        'source': params.source,
        'orderno': orderno,
        'rememberCard': this.checked.toString(),
        'currency': currency,
        'time': time,
        'paymentOn': this.paymentOn,
        'specialRequirements': this.$refs['specialRequirements'].value,
        'sessionid': sessionid,
        'initUrl': initUrl,
        'generatedPayData': JSON.stringify(generatedPayData),
        'generatedShieldData': JSON.stringify(generatedShieldData),
        'operation': 'writePayFinishBook'
      }
      var orderFinishBook = this.common.encryptionData(orderFinishBookJson, this)

      // pingpong 支付 返回则直接跳转
      if (this.pingpongPayResult()) {
        // 点击完成 埋点记录
        this.clickPageAction('PayNow', '', {'orderno': orderno, 'payMethod': orderFinishBook.paymentOn}, orderFinishBook, {})
        this.fullscreenLoading = false
        return false
      }

      // 其他支付方式
      writePayFinishBook(orderFinishBook).then(res => {
        // 点击完成 埋点记录
        this.clickPageAction('PayNow', '', {'orderno': orderno, 'payMethod': orderFinishBook.paymentOn}, orderFinishBook, res)
        this.fullscreenLoading = false

        // 无母房型有报价、至少有一个母房型有报价、涨价 显示取消订单按钮
        if (['155', '154', '153', '163', '173'].includes(res.flag)) {
          this.showCancel = '1'
        }
        if (res.flag === '001') {
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          let newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          if (this.conver === 1 || this.conver === '1') {
            newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
          }
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else if (['006', '007'].includes(res.flag)) { // 未支付、已支付直接跳转结果页.
          let newQuerys = this.common.linkEncode({'source': this.source, 'orderno': orderno}, 'obj')
          if (this.conver === 1 || this.conver === '1') {
            newQuerys = this.common.linkEncode({'source': this.source, 'orderno': orderno, 'conver': this.conver}, 'obj')
          }
          this.$router.push({name: 'PayCallbackResult', params: {'querys': newQuerys}})
        } else if (res.flag === '005') {
          // 安全码错误
          this.securityCodeShow = true
          this.$refs['securityCode'].focus()
        } else if (['172', '174'].includes(res.flag)) {
          // 卡支付错误
          if (res.flag === '172') {
            this.framePaymentCustomizeText = res.data.description
            this.framePaymentCustomizeFailDialog = true
          } else if (res.flag === '174') {
            // 3ds url
            window.location.href = res.data.threeDRedirectUrl
          }
        } else if (res.flag === '010') {
          this.frameNoticePublicShowText = res.msg
          this.frameNoticePublicShow = true
        } else if (res.flag === '155') {
          this.framePaymentFailDialog = false
          // 无母房型有报价
          if (language === 'zh') {
            this.frameHotelSoldDialog = true
          } else {
            this.frameHotelSoldEnDialog = true
          }
        } else if (res.flag === '154') {
          // 至少有一个母房型有报价
          this.framePaymentFailDialog = false
          this.frameHomeSoldDialog = true
        } else if (['153', '163', '173'].includes(res.flag)) {
          if (this.pageRefresh === 0 && res.data.time !== 0) {
            var dateTime = (parseInt(new Date().getTime() / 1000) - res.data.time)
            if (dateTime <= this.orderPayPageTime) {
              this.remainTime = this.orderPayPageTime - dateTime
            } else {
              this.remainTime = 0
            }
            this.minute = Math.floor((this.remainTime / 60) % 60)
            this.second = Math.floor(this.remainTime % 60)
            this.countDowm()
          }
          // 涨价
          this.framePaymentFailDialog = false
          if (res.flag === '153') {
            // 涨价
            this.frameRiseDialog = true
            this.risePrice = res.data.priceRise
          } else if (res.flag === '163') {
            // 房型变更
            this.frameChangeRoomDialog = true
            this.sameRoomInfo = res.data.sameRoomInfo
          } else if (res.flag === '173') {
            // 房型变更 房价变更
            this.frameChangePriceAndRoomDialog = true
            this.sameRoomInfo = res.data.sameRoomInfo
            this.risePrice = res.data.priceRise
          }
        } else if (['171'].includes(res.flag)) {
          // 微信获取openid url
          window.location.href = res.data.openid_url
        } else if (['159', '160', '158', '200', '175'].includes(res.flag)) {
          if (acName !== 'electronicPayment') {
            // 成功
            var orderResultData = {
              'hotelid': params.hotelid,
              'product': params.product,
              'checkin': params.checkin,
              'checkout': params.checkout,
              'room': params.room,
              'adult': params.adult,
              'child': params.child,
              'childNums': params.childNums !== undefined ? params.childNums : '',
              'source': params.source,
              'orderno': orderno,
              'flag': res.flag,
              'paymentOn': orderFinishBook.paymentOn,
              'paymentSign': res.data.paymentSign,
              'paymentSkipUrl': res.data.url
            }
            localStorage.setItem('orderResultData', JSON.stringify(orderResultData))

            this.paymentSign = res.data.paymentSign

            this.frameRenewDialog = true
            this.cardPolling()
            // let newQuerys = this.common.linkEncode({'source': params.source}, 'obj')
            // orderResultData['querys'] = newQuerys
            // this.$router.push({name: 'Waiting', params: orderResultData})
          } else {
            var orderInfoData = {
              'hotelid': params.hotelid,
              'product': params.product,
              'checkin': params.checkin,
              'checkout': params.checkout,
              'room': params.room,
              'adult': params.adult,
              'child': params.child,
              'childNums': params.childNums !== undefined ? params.childNums : '',
              'source': params.source,
              'orderno': orderno,
              'paymentOn': orderFinishBook.paymentOn,
              'paymentSkipUrl': res.data.url
            }
            localStorage.setItem('orderData', JSON.stringify(orderInfoData))

            // wechat 区分与其他的支付
            if (orderFinishBook.paymentOn === 'wechat' && orderFinishBook.flag === 'mobile' && orderFinishBook.ua.indexOf('MicroMessenger') !== -1) { // 微信自带浏览器 支付
              this.frameRenewDialog = true
              // 微信js支付
              console.log('微信支付')
              console.log(res.data.payRequest)
              this.wxJsPay(res.data.payRequest)
            } else if (orderFinishBook.paymentOn === 'wechat' && orderFinishBook.flag === 'website') { // 微信PC 支付
              console.log('微信支付:' + res.data.url)
              this.wechatEject = true
              this.weChatImgUrl = res.data.url
            } else if (orderFinishBook.paymentOn === 'wechat' && orderFinishBook.flag === 'mobile') { // 微信h5 支付
              console.log('微信支付:' + res.data.url)
              this.frameRenewDialog = true
              this.wechatH5Polling()
              window.location.href = res.data.url
            } else {
              // this.$router.push({name: 'Waiting', params: orderInfoData})
              let newQuerys = this.common.linkEncode({'source': params.source}, 'obj')
              if (this.conver === 1 || this.conver === '1') {
                newQuerys = this.common.linkEncode({'source': params.source, 'conver': this.conver}, 'obj')
              }
              orderInfoData['querys'] = newQuerys
              this.$router.push({name: 'Waiting', params: orderInfoData})
            }
          }
        }
      })
    },
    // 卡支付 轮询 支付状态 跳转到回调页面
    cardPolling: function () {
      var that = this
      var num = 0

      if (this.cardStatus !== '') {
        return false
      }

      // 2秒请求一次 60秒钟跳转结果页面
      this.cardStatus = setInterval(function () {
        // pingpong支付 大于60秒则跳转到支付结果页面
        if (num >= 10) {
          clearInterval(that.cardStatus)
          that.cardStatus = ''
          that.cardJumpOver()
        }
        num++

        // 查询当前订单状态
        var params = that.$route.params
        var orderno = that.common.linkQuerys.orderno
        var orderData = localStorage.getItem('orderData')
        if (JSON.stringify(params) === '{}' && orderData !== '{}') {
          params = JSON.parse(orderData)
          if (orderno === undefined) {
            orderno = params.orderno
          }
        }

        var language = that.common.languageSet(that)
        var currency = that.common.currencySet(that)
        var time = parseInt(new Date().getTime() / 1000)
        var sessionid = that.common.sessionidGet(that)

        // 验证verify
        var token = that.$md5('0' + that.common.lfSignKey)
        if (localStorage.getItem('token')) {
          token = localStorage.getItem('token')
        }

        var payData = {
          'token': token,
          'hotelid': params.hotelid,
          'checkin': params.checkin,
          'checkout': params.checkout,
          'room': params.room,
          'adult': params.adult,
          'child': params.child,
          'childNums': params.childNums !== undefined ? params.childNums : '',
          'product': params.product,
          'source': params.source,
          'orderno': orderno,
          'language': language,
          'currency': currency,
          'sessionid': sessionid,
          'paymentOn': that.paymentOn,
          'operation': 'paymentOrderData',
          'time': time
        }
        var payDataJson = that.common.encryptionData(payData, that)
        orderPayment(payDataJson).then(res => {
          if (res.flag === '200') {
            if (res.data.payStatus === 'finish' || res.data.payStatus === 'SUCCESS') {
              clearInterval(that.cardStatus)
              that.cardStatus = ''
              // 加载
              that.cardJumpOver()
            } else if (res.data.payStatus === 'not') {
              clearInterval(that.cardStatus)
              that.cardStatus = ''
              that.fullscreenLoading = false
            }
          }
        })
      }, 3000)
    },
    // 卡支付 回调
    cardJumpOver: function () {
      // 如果没有遮罩层 则添加遮罩层
      if (this.frameRenewDialog !== true) {
        this.frameRenewDialog = true
      }

      // 请求回调接口
      // 历史信息
      var params = this.$route.params
      var orderno = this.common.linkQuerys.orderno
      var orderData = localStorage.getItem('orderData')
      if (JSON.stringify(params) === '{}' && orderData !== '{}') {
        params = JSON.parse(orderData)
        if (orderno !== undefined) {
          orderno = params.orderno
        }
      }
      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }

      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)

      window.location.href = '/api/orderBook?operation=paymentCallback&payType=credit-card&time=' + time + '&roompaiOrderno=' + orderno + '&source=' + params.source + '&user_token=' + token + '&sessionid=' + sessionid + '&environment=test&paymentSign=' + this.paymentSign
    },
    // 微信手机支付 轮询 支付状态 跳转到回调页面
    wechatH5Polling: function () {
      var that = this
      var num = 0
      // 如果没有遮罩层 则添加遮罩层
      if (this.frameRenewDialog !== true) {
        this.frameRenewDialog = true
      }
      if (this.wechatH5Status !== '') {
        return false
      }

      // 1秒请求一次 10秒钟跳转结果页面
      this.wechatH5Status = setInterval(function () {
        // h5支付 大于20秒则跳转到支付结果页面
        if (num >= 10) {
          clearInterval(that.wechatH5Status)
          that.wechatH5Status = ''
          that.wechatJumpOver()
        }
        num++
        // 查询当前订单状态
        var params = that.$route.params
        var orderno = that.common.linkQuerys.orderno
        var orderData = localStorage.getItem('orderData')
        if (JSON.stringify(params) === '{}' && orderData !== '{}') {
          params = JSON.parse(orderData)
          if (orderno !== undefined) {
            orderno = params.orderno
          }
        }

        var language = that.common.languageSet(that)
        var currency = that.common.currencySet(that)
        var time = parseInt(new Date().getTime() / 1000)
        var sessionid = that.common.sessionidGet(that)

        // 验证verify
        var token = that.$md5('0' + that.common.lfSignKey)
        if (localStorage.getItem('token')) {
          token = localStorage.getItem('token')
        }

        var payData = {
          'token': token,
          'hotelid': params.hotelid,
          'checkin': params.checkin,
          'checkout': params.checkout,
          'room': params.room,
          'adult': params.adult,
          'child': params.child,
          'childNums': params.childNums !== undefined ? params.childNums : '',
          'product': params.product,
          'source': params.source,
          'orderno': orderno,
          'language': language,
          'currency': currency,
          'sessionid': sessionid,
          'paymentOn': that.paymentOn,
          'operation': 'paymentOrderData',
          'time': time
        }
        var payDataJson = that.common.encryptionData(payData, that)
        orderPayment(payDataJson).then(res => {
          if (res.flag === '200') {
            if (res.data.payStatus === 'finish') {
              that.wechatJumpOver()
              clearInterval(that.wechatH5Status)
              that.wechatH5Status = ''
            }
          }
        })
      }, 2000)
    },
    // 微信支付 回调
    wechatJumpOver: function () {
      // 如果没有遮罩层 则添加遮罩层
      if (this.frameRenewDialog !== true) {
        this.frameRenewDialog = true
      }

      // 请求回调接口
      // {"PayerID":"4MBFCD7VEG7EQ","operation":"paymentCallback","payType":"paypal","roompaiOrderno":"YG033197116","time":"1680256566","token":"6BG53584KR1101907","user_token":"462f8cbd0db49354ab16d405d9af1256"}
      // 历史信息
      var params = this.$route.params
      var orderno = this.common.linkQuerys.orderno
      var orderData = localStorage.getItem('orderData')
      if (JSON.stringify(params) === '{}' && orderData !== '{}') {
        params = JSON.parse(orderData)
        if (orderno !== undefined) {
          orderno = params.orderno
        }
      }
      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }

      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)

      window.location.href = '/api/orderBook?operation=paymentCallback&payType=wechat&time=' + time + '&roompaiOrderno=' + orderno + '&source=' + params.source + '&user_token=' + token + '&sessionid=' + sessionid + '&environment=test'
    },
    // 微信js支付签名
    wechatJsSign: function () {
      var that = this

      var params = this.$route.params
      var orderno = this.common.linkQuerys.orderno
      var orderData = localStorage.getItem('orderData')
      if (JSON.stringify(params) === '{}' && orderData !== '{}') {
        params = JSON.parse(orderData)
        if (orderno === undefined) {
          orderno = params.orderno
        }
      }

      var time = parseInt(new Date().getTime() / 1000)
      var payData = {
        'url': window.location.href.split('#')[0],
        'orderno': orderno,
        'operation': 'wechatJsPayGetSign',
        'time': time
      }
      var payDataJson = this.common.encryptionData(payData, this)
      wechatJsPayGetSign(payDataJson).then(res => {
        const config = res.data
        that.wx.config({
          debug: false,
          appId: config.appId,
          timestamp: config.timestamp,
          nonceStr: config.nonceStr,
          signature: config.signature,
          jsApiList: ['chooseWXPay', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo']
        })
      })
    },
    // 微信js支付
    wxJsPay: function (payRequest) {
      var that = this
      this.wx.ready(function () {
        that.wx.chooseWXPay({
          appId: payRequest.appId,
          timestamp: payRequest.timeStamp,
          nonceStr: payRequest.nonceStr,
          package: payRequest.package,
          signType: payRequest.signType,
          paySign: payRequest.paySign,
          success: function (res) {
            // 支付成功的回调函数
            console.log('-------成功------')
            that.wechatJumpOver()
          },
          fail: function (res) {
            // 支付失败的回调函数
            console.log('-------失败------')
            that.wechatJumpOver()
          },
          cancel: function (res) {
            // 用户取消支付的回调函数
            console.log('------取消-------')
            that.frameRenewDialog = false
          }
        })
      })
    },
    // pingpong 支付结果
    pingpongJumpOver: function () {
      var pingpongPayStatus = this.orderData.pingpong_pay_status

      // 等待页面 轮询结果
      if (pingpongPayStatus === 1) {
        this.fullscreenLoading = true
        // 轮询结果
        this.pingpongPolling()
        return false
      }

      // 失败 需要特殊弹框
      if (pingpongPayStatus === 3) {
        // 如果非订单详情页  点击进入支付页
        if (this.showCancel !== '1' && this.showCancel !== 1) {
          this.framePaymentFailDialog = true
          this.frameDialog = false
          this.frameQuotationDialog = false
          this.frameRemindDialog = false
          this.frameHotelSoldDialog = false
          this.frameHotelSoldEnDialog = false
          this.frameHomeSoldDialog = false
          this.frameRiseDialog = false
          this.frameLastDialog = false
        }
        return false
      }

      // 支付成功 请求回调接口
      // 历史信息
      var source = this.common.linkQuerys.source
      var orderno = this.common.linkQuerys.orderno

      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }

      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)

      window.location.href = '/api/orderBook?operation=paymentCallback&payType=pingpong&time=' + time + '&roompaiOrderno=' + orderno + '&source=' + source + '&user_token=' + token + '&sessionid=' + sessionid + '&environment=pingpong'
    },
    orderVerify: function () {
      // 请求验价数据
      var language = this.common.languageSet(this)
      let locationHref = window.document.location.href
      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var params = this.$route.params
      var orderData = localStorage.getItem('orderData')
      if (JSON.stringify(params) === '{}' && orderData !== '{}') {
        params = JSON.parse(orderData)
      }

      var currency = this.common.currencySet(this)
      var time = parseInt(new Date().getTime() / 1000)
      var requestTime = parseInt(new Date().getTime())
      var sessionid = this.common.sessionidGet(this)

      var verifyJson = {
        'hotelid': params.hotelid,
        'product': params.product,
        'token': token,
        'room': params.room,
        'adult': params.adult,
        'child': params.child,
        'childNums': params.childNums !== undefined ? params.childNums : '',
        'checkin': params.checkin,
        'checkout': params.checkout,
        'currency': currency,
        'source': this.source,
        'pageRefresh': this.pageRefresh,
        'sessionid': sessionid,
        'operation': 'orderBookVerify',
        'time': time
      }
      var verifyData = this.common.encryptionData(verifyJson, this)
      orderBookVerify(verifyData).then(res => {
        this.frameQuotationDialog = false
        if (res.flag === '001') {
          // 未登录
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          // this.$router.push({name: 'login', query: {'source': this.source}})
          var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          if (this.conver === 1 || this.conver === '1') {
            newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
          }
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else if (['155', '150'].includes(res.flag)) {
          // 无母房型有报价
          this.framePaymentFailDialog = false
          if (language === 'zh') {
            this.frameHotelSoldDialog = true
          } else {
            this.frameHotelSoldEnDialog = true
          }
        } else if (res.flag === '154') {
          // 至少有一个母房型有报价
          this.framePaymentFailDialog = false
          this.frameHomeSoldDialog = true
        } else if (['153', '163', '173', '200'].includes(res.flag)) {
          if (this.orderData.order_status === 4 || this.orderData.order_status === '4') {
            return false
          }
          if (this.pageRefresh === 0 && res.data.time !== 0) {
            var dateTime = (parseInt(new Date().getTime() / 1000) - res.data.time)
            if (dateTime <= this.orderWritePageTime) {
              this.remainTime = this.orderWritePageTime - dateTime
            } else {
              this.remainTime = 0
            }
            this.minute = Math.floor((this.remainTime / 60) % 60)
            this.second = Math.floor(this.remainTime % 60)
            this.countDowm()
          }

          if (res.flag === '153') {
            // 涨价
            this.framePaymentFailDialog = false
            this.frameRiseDialog = true
            this.risePrice = res.data.priceRise
            if (res.data.verifyCurrency) {
              localStorage.setItem('currencySet', res.data.verifyCurrency)
            }
          } else if (res.flag === '163') {
            // 变更房型
            this.frameChangeRoomDialog = true
            this.sameRoomInfo = res.data.sameRoomInfo
            if (res.data.verifyCurrency) {
              localStorage.setItem('currencySet', res.data.verifyCurrency)
            }
          } else if (res.flag === '173') {
            // 涨价，且变更房型
            this.frameChangePriceAndRoomDialog = true
            this.sameRoomInfo = res.data.sameRoomInfo
            this.risePrice = res.data.priceRise
            if (res.data.verifyCurrency) {
              localStorage.setItem('currencySet', res.data.verifyCurrency)
            }
          } else if (res.flag === '200') {
            // 成功
            // location.reload()
          }
        }
        return res
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(verifyData, res, requestTime, responseTime, 'confirmPrice')
        })
      })
    },
    continueBookingFun: function (val) {
      // 继续预订 记录埋点
      this.clickPageAction('continue_order', '', {})

      this.frameRemindDialog = false
      this.pageRefresh = 0
      this.framePaymentFailDialog = false
      this.frameQuotationDialog = true
      this.orderVerify()
    },
    frameRiseBookingBackFun: function (val) {
      this.frameRiseDialog = false
      this.pageRefresh = 0
    },
    frameRiseBookingFun: function (val) {
      this.frameRiseDialog = false
      this.pageRefresh = 0
      this.JumpOver()
    },
    frameChangeRoomBookingBackFun: function (val) {
      this.frameChangeRoomDialog = false
      this.pageRefresh = 0
    },
    frameChangeRoomBookingFun: function (val) {
      this.frameChangeRoomDialog = false
      this.pageRefresh = 0
      this.JumpOver()
    },
    frameChangePriceAndRoomBookingBackFun: function (val) {
      this.frameChangePriceAndRoomDialog = false
      this.pageRefresh = 0
    },
    frameChangePriceAndRoomBookingFun: function (val) {
      this.frameChangePriceAndRoomDialog = false
      this.pageRefresh = 0
      this.JumpOver()
    },
    // 网络中断请重试
    frameNoticeFun: function (val) {
      this.JumpOver()
    },
    frameNoticePublicFun: function (val) {
      this.frameNoticePublicShow = false
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    countDowm () {
      var self = this
      clearInterval(this.promiseTimer)
      this.promiseTimer = setInterval(function () {
        if (self.minute !== 0 && self.second === 0) {
          self.second = 59
          self.minute -= 1
        } else if (self.minute === 0 && self.second === 0) {
          self.second = 0
          self.$emit('countDowmEnd', true)
          clearInterval(self.promiseTimer)
          self.pageVerifyNum++
          // self.frameRiseDialog = true
        } else {
          self.second -= 1
        }
      }, 1000)
    },
    formatNum (num) {
      return num < 10 ? '0' + num : '' + num
    },
    refresh () {
      location.reload()
      this.frameDialog = false
      this.frameRiseDialog = false
    },
    reserve () {
      this.frameRiseDialog = false
      if (this.framePaymentFailDialog === false) {
        this.frameDialog = true
      }
    },
    login () {
      // 其他客户
      var userOtherInfo = []
      for (let index = 2; index <= this.guestRoomNum; index++) {
        var userlastnameR = this.$refs['userlastname' + index][0].value
        var usernameR = this.$refs['username' + index][0].value
        var nationalityR = this.selectNat[index]
        var userOtherR = {'userlastname': userlastnameR, 'username': usernameR, 'nationality': nationalityR}
        userOtherInfo.push(userOtherR)
      }

      // 获取用户填写信息
      var userlastname1 = this.$refs['userlastname1'].value
      var username1 = this.$refs['username1'].value
      var emails = this.$refs['emails'].value
      var tel1 = this.$refs['tel1'].value
      var specialRequirements = this.$refs['specialRequirements'].value

      // 用户订单数据 存入 localStorage
      var orderUserData = {
        'roomHost': {'userlastname': userlastname1, 'username': username1, 'emails': emails, 'tel': tel1, 'specialRequirements': specialRequirements, 'areaCode': this.selectTel, 'nationality': this.selectNat[1]},
        'roomOther': userOtherInfo
      }
      sessionStorage.setItem('orderUserData', JSON.stringify(orderUserData))

      let locationHref = window.document.location.href
      sessionStorage.setItem('LoginWebsiteAddress', locationHref)
      // this.$router.push({name: 'login', query: {'source': this.source}})
      var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
      if (this.conver === 1 || this.conver === '1') {
        newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
      }
      this.$router.push({name: 'login', params: {'querys': newQuerys}})
    },
    loginOut: function () {
      // 判断用户是否登录 获取用户信息
      var token = localStorage.getItem('token')
      if (token !== undefined && token !== '' && token !== null) {
        this.loginStatus = false
        localStorage.removeItem('token')
        localStorage.removeItem('sessionid')
        localStorage.removeItem('LoginWebsiteAddress')
        var time = parseInt(new Date().getTime() / 1000)
        var dataJson = {'token': token, 'operation': 'loginOut', 'time': time}
        var data = this.common.encryptionData(dataJson, this)
        signIn(data).then(res => {
          this.$nextTick(() => {
            // 埋点日志记录
            let logData = {
              'name': this.$route.name,
              'path': this.$route.path
            }
            this.clickPageAction('loginOut', '', logData, data, res)
          })
          location.reload()
        })
      }
    },
    getPolicyDia (val) {
      this.policyDialog = val
    },
    getClauseDia (val) {
      this.clauseDialog = val
    },
    changePayment (scope) {
      let brand = scope
      for (let index in this.paymentList) {
        let aa = this.paymentList[index]
        let value = aa.value
        if (brand === value) {
          this.$refs.paymentSelect.$el.children[0].children[0].setAttribute('style', 'background:url(' + aa.src + ') no-repeat 20px;background-size: 38px 25px;color: #333;padding-left: 70px;')
        }
      }
    },
    changePaymentMobile (scope) {
      let brand = scope
      for (let index in this.paymentMobileList) {
        let aa = this.paymentMobileList[index]
        let value = aa.value
        if (brand === value) {
          this.$nextTick(() => { this.$refs.paymentSelectMobile.$el.children[0].children[0].setAttribute('style', 'background:url(' + aa.src + ') no-repeat 20px;background-size: 38px 25px;color: #333;padding-left: 70px;') })
        }
      }
    },
    changePaymentCardno (cardno) {
      for (let index in this.payment.list) {
        let aa = this.payment.list[index]
        let sign = aa.sign
        if (cardno === sign) {
          this.paymentCardnoName = aa.cardholder_name
          this.paymentCardnoEffectivedate = aa.effectivedate
          this.paymentCardnoValidCVV = aa.effectivedate
        }
      }
    },
    changePaymentCardnoMobile (cardno) {
      for (let index in this.payment.list) {
        let aa = this.payment.list[index]
        let sign = aa.sign
        if (cardno === sign) {
          var urlsrc = ''
          if (aa.type === 'visa') {
            urlsrc = 'https://res.roompai.com/static/img/order/visa.png'
          }
          if (aa.type === 'master') {
            urlsrc = 'https://res.roompai.com/static/img/order/mastercard.png'
          }
          // console.log(this.$refs.paymentCardnoMobile)
          this.$refs.paymentCardnoMobile.$el.children[0].children[0].setAttribute('style', 'background:url(' + urlsrc + ') no-repeat 20px;background-size: 38px 25px;color: #333;padding-left: 70px;')

          this.paymentCardnoName = aa.cardholder_name
          this.paymentCardnoEffectivedate = aa.effectivedate
          this.paymentCardnoValidCVV = aa.effectivedate
        }

        this.showCardRemind = false
        this.showCardRemindTwo = false
      }
    },
    linkClick (type, click = '1') {
      // 点击 记录埋点
      if (type === 'clause') {
        if (click === '2') {
          this.clauseDialog = true
        }
        this.clickPageAction('writePayment_terms_use', '', {})
      } else if (type === 'policy') {
        if (click === '2') {
          this.policyDialog = true
        }
        this.clickPageAction('writePayment_privacy_policy', '', {})
      }
    },
    pingpongPaymentWrap: function () {
      if (this.orderData.pay_way !== 'pingpong') {
        return false
      }

      /*
      // vi 版本
      const conf = {
        mode: 'sandbox', // sandbox/ (必填参数)
        // mode: 'production', // sandbox/production (必填参数)
        lang: this.language, // 语言，不传默认英语 - de德语 en英语 es西班牙语 fr法语 it意大利语 ru俄语 zh中文 jp日语
        root: '#payment-pingpong', // PingPong收银台在哪个元素上渲染 须为id (必填)
        manul: true, // 手动模式。 即：支付按钮需要自己渲染，开启后可使用client.actionPayment()方法调用支付
        showPrice: false, // 是否展示价格
        bill: false, // 是否显示bill
        located: false, // 是否显示located(默认为true)
        menu: false, // 是否显示支付方式按钮
        showSecureTip: false, // 安全
        base: {
          width: '100%', // 收银台宽度
          height: '400px', // 收银台高度
          backgroundColor: '#fff', // 收银台整体背景色
          // 顶部价格及币种
          priceBgColor: '#fff', // 顶部价格区域背景色
          priceFontColor: '#1fa0e8', // 顶部价格字体颜色
          priceFontSize: '32px', // 顶部价格字体大小
          priceMB: '10px', // 顶部价格区域距底部间距

          // 引导标题: “How would you like to pay”
          showHeaderLabel: false, // 是否显示引导标题
          headerMB: '24px', // 引导标题距底部间距
          headerSize: '20px', // 引导标题字体大小
          headerColor: 'rgba(0, 0, 0, 0.85)', // 引导标题字体颜色
          headerfontWeight: 700, // 引导标题加粗

          // 支付方式
          payMethodsWidth: '240px', // 支付方式按钮宽度
          payMethodsHeight: '48px', // 支付方式按钮高度
          payMethodsColor: 'rgba(0, 0, 0, 0.85)', // 支付方式按钮字体颜色
          payMethodsActiveColor: '#1fa0e8', // 支付方式按钮点击后字体颜色
          payMethodsFontsize: '14px', // 支付方式按钮字体大小
          payMethodsActiveBorderColor: '#1fa0e8', // 支付方式按钮点击后边框颜色
          payMethodsActiveBorderShadow: '0 2px 8px 0 rgb(31 160 232 / 20%)', // 支付方式按钮点击后阴影
          showIcons: false, // 是否显示卡图标
          showHeaderAmount: false, // 是否显示头部支付金额
          // 表单相关
          formItemMargin: '16px', // 表单距底部间距
          formItemBorderColor: 'rgba(0, 0, 0, 0.08)', // 表单边框颜色
          formItemFocusColor: '#1fa0e8', // 表单聚焦时提示文案和边框颜色

          // 支付按钮
          btnSize: '100%', // 按钮宽度百分比或者px
          btnColor: '#fff', // 按钮字体颜色
          btnFontSize: '14px', // 按钮字体大小
          btnMarginTop: '10px', // button 距顶部距离
          btnMarginBottom: '24px', // button 距底部距离
          btnBackgroundColor: '#1fa0e8', // 按钮背景色
          btnBorderRadius: '8px', // 按钮圆角
          btnBorderColor: '#1fa0e8' // 可单独配置btn边框颜色覆盖btnBorder中设置的颜色
        }
      }
      this.pingpongPayClient = new ppPay(conf)
      // 在这里传入 从接口中获取到的token
      let token = this.orderData.pay_url
      // 使用此方法将会创建收银台
      this.pingpongPayClient.createPayment(token)
      */

      // v2 版本
      this.pingpongAccessToken = this.orderData.pay_url
      window.PingPong.Checkout.customizeStyles = {
        themeType: 'light',
        themeColor: 'rgb(54, 175, 3)',
        themeColorLight: 'rgba(54, 175, 3, 0.4)'
      }
      window.PingPong.Checkout.customizeConfig = {
        originalPay: false // 不使用默认的 PingPong 支付按钮
      }

      // 滚动到pingpong loading
      this.$nextTick(() => {
        const element = document.querySelector('#paymentTypeTop')
        if (element) {
          element.scrollIntoView({behavior: 'smooth'})
        }
      })

      // manul 模式 使用此方法将不会出现支付按钮，支付时机将会取决于持卡人的调用
      // client.actionPayment(function () {
      //   console.log(1231231231)
      // })
    },
    pingpongPayResult: function () {
      // 如果是pingpong 则调用对方方法 对方跳转我们的支付结果页面
      if (this.paymentOn === 'pingpong') {
        this.fullscreenLoading = true
        // this.pingpongPayClient.actionPayment()
        window.PingPong.Checkout.pay.run()
        this.pingpongPolling()
        return true
      }

      return false
    },
    pingpongPolling: function () {
      var that = this
      var num = 0

      if (this.pingpongStatus !== '') {
        return false
      }

      // 2秒请求一次 60秒钟跳转结果页面
      this.pingpongStatus = setInterval(function () {
        // pingpong支付 大于60秒则跳转到支付结果页面
        if (num >= 20) {
          clearInterval(that.pingpongStatus)
          that.pingpongStatus = ''
          // that.pingpongJumpOver()
          window.location.reload()
        }
        num++

        // 查询当前订单状态
        var params = that.$route.params
        var orderno = that.common.linkQuerys.orderno
        var orderData = localStorage.getItem('orderData')
        if (JSON.stringify(params) === '{}' && orderData !== '{}') {
          params = JSON.parse(orderData)
          if (orderno === undefined) {
            orderno = params.orderno
          }
        }

        var language = that.common.languageSet(that)
        var currency = that.common.currencySet(that)
        var time = parseInt(new Date().getTime() / 1000)
        var sessionid = that.common.sessionidGet(that)

        // 验证verify
        var token = that.$md5('0' + that.common.lfSignKey)
        if (localStorage.getItem('token')) {
          token = localStorage.getItem('token')
        }

        var payData = {
          'token': token,
          'hotelid': params.hotelid,
          'checkin': params.checkin,
          'checkout': params.checkout,
          'room': params.room,
          'adult': params.adult,
          'child': params.child,
          'childNums': params.childNums !== undefined ? params.childNums : '',
          'product': params.product,
          'source': params.source,
          'orderno': orderno,
          'language': language,
          'currency': currency,
          'sessionid': sessionid,
          'paymentOn': that.paymentOn,
          'operation': 'paymentOrderData',
          'time': time
        }
        var payDataJson = that.common.encryptionData(payData, that)
        orderPayment(payDataJson).then(res => {
          if (res.flag === '200') {
            if (res.data.payStatus === 'finish' || res.data.payStatus === 'SUCCESS') {
              clearInterval(that.pingpongStatus)
              that.pingpongStatus = ''
              // 加载
              window.location.reload()
            } else if (res.data.payStatus === 'FAILED') {
              clearInterval(that.pingpongStatus)
              that.pingpongStatus = ''
              that.fullscreenLoading = false

              if (that.framePaymentFailDialog === false) {
                that.framePaymentFailDialog = true
              }
            } else if (res.data.payStatus === 'not') {
              clearInterval(that.pingpongStatus)
              that.pingpongStatus = ''
              that.fullscreenLoading = false
            }
          }
        })
      }, 3000)
    },
    paymentRetryClick: function () {
      this.framePaymentFailDialog = false
    },
    paymentCustomRetryClick: function () {
      this.framePaymentCustomizeText = ''
      this.framePaymentCustomizeFailDialog = false
    },
    // 重点处理输入时的逻辑
    handleEffectiveDateInput: function (event) {
      let value = this.effectivedate
      // 提取数字部分
      const numbers = value.replace(/\D/g, '')
      // console.log('value: ' + value)
      // console.log('numbers: ' + numbers)
      // 构建符合MM/YY格式的字符串
      let formattedValue = `${numbers.slice(0, 2)}`
      if (numbers.length > 2) {
        // 插入分隔符
        formattedValue = `${numbers.slice(0, 2)}/${numbers.slice(2, 4)}`
      }
      // 限制最大长度为5（MM/YY格式）
      if (formattedValue.length > 5) {
        formattedValue = formattedValue.slice(0, 5)
      }
      this.effectivedate = formattedValue
    }
  },
  computed: {
    minuteString () {
      return this.formatNum(this.minute)
    },
    secondString () {
      return this.formatNum(this.second)
    }
  }
}
</script>

<style scoped>
.main{background-color: #fff;height:auto; margin:90px auto auto;width:1100px;}

/* 步骤条 */
.stepinfo{text-align: center;margin: 30px auto; width: 100%;}
.el-step.is-center .el-step__line{left:20%; right:2%;background-color:#4F4C4C; height: 1px;top:14.5px;}
.el-step.is-center .step-two-zh{margin-right: 0px;left: 20%;right: 2%;}
.el-step.is-center .step-two-en{margin-right: 0px;left: 27%;right: 2%;}
.el-step.is-center .step-one-zh{margin-right: 0px;right: 2%;left: 20%;}
.el-step.is-center .step-one-en{margin-right: 0px;right: 2%;left: 27%;}
.step-img{width: 30px;height: 30px;vertical-align:middle;}
.step-text{color:#4F4C4C;font-size: 14px; font-weight: 600;}
.order-step{width: 497px; margin-right: 0px;}
.div-hidden{display:none}

/* 左侧开始 */
.msg-left{ width:736px;display:inline-block;float:left; margin-right:12px;}
/* 登录/注册账号入口 */
.msg-blue{height:50px;font-size: 14px;background-color: rgba(233, 238, 249, 1);border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%); margin-bottom: 12px;}
.blue-back{border:none; width:50px; height:50px; background-color:#5392F9;vertical-align:middle;}
.blue-logo, .orange-logo{width: 30px;height: 30px; float:left; margin: 10px;}
.msg-blue div, .msg-orange div{display:inline-block; float: left;}
.blue-text{line-height:50px; height:50px;}
.blue-maintext{color:#5392F9; font-weight:650;padding: 0px 10px;cursor: pointer;}
.email-maintext{color:#303133; font-weight: 650;padding: 0px 10px;}
.msg-pink{height:50px; color:#F56C6C;font-size: 14px;background-color: rgba(254, 240, 240, 1);border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);}
.pink-back{border:none; width:50px; height:50px; background-color:rgba(245, 108, 108, 1);vertical-align:middle;}
.pink-logo{width: 30px;height: 30px; float:left; margin: 10px;}
.msg-pink div, .msg-green div{display:inline-block; float: left;}
.pink-text{line-height:50px; height:50px; padding-left:10px;}
.pink-maintext{font-weight:650; color:#F56C6C;}

.msg-green{height:17px;font-size: 14px; border: none;margin:0px 0px 10px;line-height: 17px;}
.green-back{border:none; width:17px; height:17px; vertical-align:middle;}
.green-text-zh,.green-text-en{min-height:20px; color:#67C23A;}
.green-logo{width: 17px;height: 17px; float:left;margin:0}

/* 时间倒计时 */
.msg-orange{height:50px;font-size: 14px; color:#E6A23C; background-color: rgba(253, 246, 236, 1);border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);}
.msg-bule-show{margin-top:10px;}
.orange-back{border:none; width:50px; height:50px; background-color:rgba(230, 162, 60, 1);vertical-align:middle;}
.orange-text{line-height:50px; height:50px; padding-left:10px;}
.orange-maintext{font-weight:650;}
/* 住客资料 */
.input-bor /deep/ .el-select .el-input.is-focus .el-input__inner,.input-bor /deep/ .el-select .el-input__inner:focus{border-color:rgb(252, 210, 5, 1);box-shadow: 0px 0px 8px rgb(252 210 5);}
.codeError,.codeError:focus,.codeError:hover{background: inherit;background-color: rgba(255, 255, 255, 1);box-sizing: border-box;border: 2px solid rgba(225, 45, 45, 1);border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.msg-guest{border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);margin-top:10px;padding-bottom:20px;}
.msg-lastname,.msg-username{width:49%;display:inline-block;}
.msg-name{text-align: right;vertical-align: middle;float: left;font-size: 14px;color: #606266;line-height: 40px; padding: 0 12px 0 0;-webkit-box-sizing: border-box;box-sizing: border-box;}
.msg-guest{ font-size:13px;}
.msg-guest input:hover{ border-color:rgb(79, 76, 76, 1);}
.msg-guest input:focus{ border-color:rgb(252, 210, 5, 1);box-shadow: 0px 0px 8px rgb(252 210 5);}
.msg-guest .el-form-item__error{color:#E12D2D; font-size:12px;}
.el-select-dropdown {display:block;}
.msg-empty{ border-color: #E12D2D;}
.el-form-item__error{color:#E12D2D;}
.remind-font{font-size:14px;}
.remind-text{color:#5392F9; font-weight:650;text-decoration:none;}
.tonext{padding: 2px 20px; text-align:right;}
/deep/ .el-checkbox__input.is-checked+.el-checkbox__label{color:#5392F9;}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner, /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner{ background-color: #5392F9; border-color: #5392F9;}

/* 特殊要求 */
.specialText{height: 80px; /* line-height: 80px; */ font-size: 14px;padding: 0px;border:none;}
.specialText /deep/ textarea{height:100%;resize:none}
/deep/ .el-textarea .el-input__count{background: rgb(255, 255, 255, 0.7)}
.surplus-room{font-size:12px; color:#E12D2D;}
/* 搜索 */
.order_button{width:30%;height:51px;font-size:16px; font-weight:650; background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);border-radius:6px;}
.order_button:hover{background:rgba(79, 76, 76, 1);color:rgba(252, 210, 5, 1);border:1px solid rgba(79, 76, 76, 1);}
.order_button:focus{background:rgba(79, 76, 76, 1);color:rgba(252, 210, 5, 1);border:1px solid rgba(79, 76, 76, 1);}
/*取消订单*/
.cancel_order_button{background: inherit;background-color: rgba(255, 255, 255, 1);box-sizing: border-box;border-width: 1px;border-style: solid;border-color: rgba(225, 226, 239, 1);border-radius: 6px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;font-weight: 650;font-style: normal;font-size: 16px;color: #4F4C4C;width:30%;height:51px;}
.cancel_order_button:hover{background:rgba(79, 76, 76, 1);color:rgba(252, 210, 5, 1);border:1px solid rgba(79, 76, 76, 1);}
.cancel_order_button:focus{background:rgba(79, 76, 76, 1);color:rgba(252, 210, 5, 1);border:1px solid rgba(79, 76, 76, 1);}
/* 右侧部分 */
.msg-right-all{width:352px; float: right;}
.msg-right{width:100%;display:inline-block;border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);margin-bottom:10px;}
/* 评分 */
.score-bar{width: 100%;-webkit-box-sizing: border-box;box-sizing: border-box;}
.scoreNo{height: 6px;border-radius: 0px 4px 4px 0px;background-color:rgba(79, 76, 76, 1);overflow: hidden;position: relative;vertical-align: middle;}
.scoreYes{height: 100%;border-radius: 0px;text-align: right;line-height: 1;white-space: nowrap;-webkit-transition: width .6s ease;transition: width .6s ease;background-color:rgba(252, 210, 5, 1);}
/* 预订信息 */
.advanceText{font-size:18px; font-weight:650; border-bottom: 1px solid rgba(221, 223, 226, 1);height: 54px; line-height: 54px; padding:0px 4.5%;}
.advanceInfo{ margin-top:13px;color:#333333;padding: 0px 4.5%;}
.titletd{ width:35%; font-size:14px; font-weight:650; display:inline-block;vertical-align: top;color:#333333;}
.infotd{ width: 60%;display: inline-block;color:#333333;}
.advanceInfo td{ padding-bottom:12px;}
.greenText{color:#2F7000;}

.redText{color:#E12D2D;}
/* 价格详情 */
.msg-price{width:28%;display:inline-block;border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%);margin-bottom:10px;}
.priceText{font-size:18px; font-weight:650;height: 54px;padding: 0px 4.5%; line-height: 54px;}
.priceInfo{background-color:rgba(221, 223, 226, 0.2980392156862745); height:auto; font-size:14px;color:#333333;}
.avgprice{display:block;color:#616161;font-size:12px;}
/* .priceInfo div{ margin-bottom:20px;} */
.jianye div{margin-bottom: 20px;}
.jianye span{margin-top:5px;}
.popverText{ font-size:12px;width:20%;}
/* 新步骤条 */
.order-step-new-zh{ display:inline-block; width: 100px;}
.order-step-new-en{display:inline-block; width: 130px; text-align:center;}
.step-line-one-zh{width:386px; left: 106px;position:relative; top: 12.5px;}
.step-line-two-zh{width: 386px;left: 608px;position:relative; top:12.5px;}
.step-line-one-en{width:342px; left: 136px;position:relative; top: 12.5px;}
.step-line-two-en{width: 349px;left: 623px;position:relative; top:12.5px;}

/* 住房须知 */
.hotelFeesText /deep/ p{margin-block-start: 5px;margin-block-end: 5px;}
.hotelFeesText /deep/ ul{margin-left:20px;margin-bottom: 10px;}

/* 住房须知 */
.hotel-detail-info-mobile{margin-top: 10px;}
.hotel-detail-info-mobile .hotel-data-info .hotel-data-info-top{width:100%;min-height: 50px;border-bottom: 1px solid rgba(221, 223, 226, 1);}
.hotel-detail-info-mobile .hotel-data-info .hotel-data-info-top-active{box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);border-radius: 5px;}
.hotel-detail-info-mobile .hotel-data-info /deep/ .el-card__body{width:100%;height:100%;padding: unset;}
.hotel-detail-info-mobile .hotel-data-info .hotel-data-info-top .hotel-overview-text{margin: 10px;width: 50%;min-height: 30px;line-height: 30px;float: left;font-size: 14px;}
.hotel-detail-info-mobile .hotel-data-info .hotel-data-info-top .hotel-overview-img{margin: 10px 20px;width: 10%;min-height: 30px;line-height: 30px;float: right;text-align:right;}
.hotel-detail-info-mobile .hotel-data-info .hotel-data-info-top .hotel-overview-img img{width:15px;height:15px;vertical-align: middle;}
.hotel-detail-info-mobile .hotel-data-info-bottom {padding:0px 10px;}
.hotel-detail-info-mobile .hotel-data-info-bottom .hotelFeesText /deep/ p{margin-block-start: 5px;margin-block-end: 5px;}
.hotel-detail-info-mobile .hotel-data-info-bottom .hotelFeesText /deep/ ul{margin-left:20px;margin-bottom: 10px;}

/* 内嵌支付 */
.payment-operational{padding: 0px !important;}
.checkout-container{padding: 0px !important;}

@media screen and (min-width: 1201px) {
.main{width:1100px;}
}
@media only screen and (min-width:1001px) and (max-width:1200px){
.main {width:95%;}
}
@media screen and (max-width: 1000px) {
.main {width:100%; margin: 0;}
.stepinfo{text-align: center; margin: 15px auto;}
.stepinfo /deep/ .el-steps{ width:360px !important; margin: 0 auto;}
.mobile-msg-main{margin:0px 10px;}
.el-step.is-center .el-step__line{left:30%;}
.el-step.is-center .step-two-zh{margin-right: 0px;left: 40%;right: -11%;}
.el-step.is-center .step-two-en{margin-right: 0px;right: -30%;left: 65%;}
.el-step.is-center .step-one-zh{margin-right: 0px;left: 40%;right: -11%;}
.el-step.is-center .step-one-en{margin-right: 0px;right: -30%;left: 65%;}
.step-text{font-size: 12px;}
.step-img{width:25px; height:25px;}
.step-text-zh{width:80px;}
.step-text-en{width:120px;}
.msg-orange{ font-size:12px;}
.mobile-msg-blue{height:50px;font-size: 12px;background-color: rgba(233, 238, 249, 1);border: none;box-shadow: 0px 2px 12px rgb(0 0 0 / 10%); margin-bottom: 12px;}
.msg-right-all,.msg-left{clear:both; width:100%;margin:0px;}
.blue-tag,.orange-tag{float:left;}
.blue-text{width: 80%; line-height: 50px;margin-left: 10px;float: left;}
.orange-text{width:80%; line-height:25px;}
.blue-maintext,.orange-text,.email-maintext{padding:0px;}
.orange-text div{display: inline-block !important;}
.msg-lastname{width:100%;display:block;margin: 0;margin-bottom: 15px;}
.msg-username{width:100%;display:block;margin: 0; height:101px;}
.tonext{text-align:right; padding: 2px 4.5%;}
.order_button{width:100%;height:48px;font-size:16px;background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);border-radius:6px;}
.order_button:focus{background:rgba(252, 210, 5, 1);color:#4F4C4C;border:1px solid rgba(252, 210, 5, 1);}
.surplus-room{float:right;}
/* .msg-guest .el-form-item__error{margin-top:8px;} */
.tax-dia .el-dialog__body{padding: 0px 15px 15px 15px !important;}
.tax-margin /deep/ .el-dialog{display: flex;flex-direction: column;margin:0 !important;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);}
.tax-margin /deep/ .el-dialog .el-dialog__body{flex:1; overflow: auto;}
.remind-font{font-size:12px;}
.advanceText, .priceText{ font-size: 16px;}

/* 新步骤条 */
.order-step-new-zh{ display:inline-block; width: 48px;}
.order-step-new-en{display:inline-block; width: 80px; text-align:center;}

}
</style>



// WEBPACK FOOTER //
// src/components/order/bookingWritePay.vue